import React, { Component, Fragment } from "react";
import NumberFormat from 'react-number-format';
import { getDataIsUser, saveDataUser,loadInfoUser} from '../../actions/adminPageAction';
import { getDataFeature} from '../../actions/authActions';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import Moment from 'react-moment';
import { Link } from "react-router-dom";
import iconLikeCmtShare from '../../icon/vip_like.png';
import iconSub from '../../icon/buff_sub.png';
import iconReview from '../../icon/buff_comment.png';
import iconLike2 from '../../icon/buff_like.png';
import iconCMT2 from '../../icon/vip_cmt.png';
import iconView from '../../icon/buff_view.png';
import iconSub2 from '../../icon/buff_share_profile.png';
import iconSub3 from '../../icon/buff_share.png';
import iconCoin from '../../icon/coin.png';
import iconCoins from '../../icon/coins.png';
import iconAdmin from '../../icon/admin.png';
import { Lightbox } from "react-modal-image";
import ModalImage from "react-modal-image";
import { FiSmile } from "react-icons/fi";
import { AiOutlineCamera, AiOutlineFileGif, AiOutlinePicture, AiOutlineLike } from "react-icons/ai";
import { BiComment } from "react-icons/bi";
import { BsReply } from "react-icons/bs";
import { FaNewspaper, FaRegUser, FaMoneyCheckAlt, FaDollarSign, FaCoins } from "react-icons/fa";
import Admin1 from '../../icon/admin1.png';
import Users1 from '../../icon/users1.png';

class Quanlytaikhoan extends Component {
	state = {
		dataUser: {},
		formdata: {
			name_user: '',
			email_user: '',
			phone_user: '',
			idfacebook_user: '',
			re_pass_user: '',
			new_pass_user: '',
		},
		loadding_page: true,
		open: false,
	}
	componentDidMount(){
		// this.props.getDataFeature(9999,'');
        // this.props.getDataIsUser().then(res => {
        	// if (res.data.status !== 200) {
				// Swal.fire({ icon: 'error', title: 'Lỗi', text: res.data.msg });
			// } else {
				// this.setState({
					// dataUser: res.data.data
				// })
			// }
        // })
        // this.props.loadInfoUser().then(res =>{
        	// this.setState({
				// formdata: {
					// ...this.state.formdata,
					// name_user: res.data.username,
					// email_user: res.data.email !== null ? res.data.email : '',
					// phone_user: res.data.phone !== null ? res.data.phone : '',
					// idfacebook_user: res.data.facebook_id !== null ? res.data.facebook_id : '',
					// notes: res.data.notes !== null ? res.data.notes : '',
				// },
				// loadding_page: false,
			// });
        // });
    }

    betwen2date = (timeCheck) => {
    	if (typeof timeCheck !== 'undefined') {
	    	const oneDay = 24 * 60 * 60 * 1000;
			const firstDate = new Date(timeCheck*1000);
			const secondDate = new Date();

			const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
			return diffDays;
    	}
    }
    ChangeInfoUser = (e) => {
		this.setState({
			formdata: {
				...this.state.formdata,
				[e.target.name]: e.target.value
			}
		});
	}
	renderImage(img){
		if (img === '{iconLikeCmtShare}') {
			return iconLikeCmtShare;
		}
		if (img === '{iconSub}') {
			return iconSub;
		}
		if (img === '{iconReview}') {
			return iconReview;
		}
		if (img === '{iconLike2}') {
			return iconLike2;
		}
		if (img === '{iconCMT2}') {
			return iconCMT2;
		}
		if (img === '{iconView}') {
			return iconView;
		}
		if (img === '{iconSub2}') {
			return iconSub2;
		}
		if (img === '{iconSub3}') {
			return iconSub3;
		}
		return img;
	}
	closeLightbox = () => {
		this.state.open = false;
	}
	openLightbox = () => {
		this.state.open = true;
	}
  	render() {
  		const {dataUser} = this.state;
  		const { listDataFeature} = this.props.adminpage;
  		const { list_noti, user, topaccount } = this.props.auth;
		const domainSite = window.location.hostname;

  		var that = this;
  		// var facebooksevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }
  						// if (value.type_category === 'Facebook') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
  		// var instagramsevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }

  						// if (value.type_category === 'Instagram') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
  		// var youtubesevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }

  						// if (value.type_category === 'Youtube') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
  		// var tiktoksevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }
  						// if (value.type_category === 'Tiktok') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
  		// var shoppesevice = (
  			// <Fragment>
  				// {
  					// listDataFeature.map(function(value,index){
  						// var classcss = 'sevice_onl';
  						// if (value.active === 'Bảo trì' || value.active === 'Dừng hoạt động') {
  							// classcss = 'sevice_offl';
  						// }
  						// if (value.type_category === 'Shoppe') {
  							// return (<Link to={value.link} className="col-md-3 px-1 mt-3 " key={index}>
  									// <div className="item-service">
  										// <div className="row p-3">
	  										// <div className=" col-md-4 img-serv-site">
	  											// <img src={that.renderImage(value.icon)} alt="group-icon" width="50" className="group-icon" />
	  										// </div>
	  										// <div className=" col-md-8 text-serv-site">
									         	// <h6 className="font-14">{value.name}</h6>
									      		// <span className={classcss}>{value.active}</span>
	  										// </div>
  										// </div>
  									// </div>
									// </Link>);
  						// } else {
  							// return ('');
  						// }
  					// })
  				// }
  			// </Fragment>
  		// );
		if (list_noti !== "") {
			var cardthongbao = (
				<Fragment>
					{
						list_noti.map(function(v, i) {
							if (i <= 10 && i !== 0) {
								return (
									<div className="card card-cus card-icon lift lift-sm mb-4" href="knowledge-base-category.html" style={{"marginBottom": "-20px"}}>
										<div className="row g-0">
											<div className={"col-auto card-icon-aside" + (i == 0 ? " bg-primary" : " bg-teal")} style={{"borderRadius": "0.35rem 0px 0px 0.35rem"}}>
												<FaNewspaper style={{"color": "#fff"}} />
											</div>
											<div className="col">
												<div className="card-body py-5" style={{whiteSpace: "pre-wrap"}}>
													<h5 className={"card-title mb-2" + (i == 0 ? " text-primary" : " text-teal")} style={{"lineBreak": "anywhere"}}>{ Buffer.from(v.title, 'base64').toString('utf8') }</h5>
													<p className="card-text mb-1" style={{"lineBreak": "anywhere"}}>{ Buffer.from(v.content, 'base64').toString('utf8') }</p>
													<div className="small text-muted"><Moment format="Ngày DD/MM/YYYY">{v.create_at * 1000}</Moment></div>
												</div>
											</div>
										</div>
									</div>
								);
							} else {
								return ('');
							}
						})
					}
				</Fragment>
			);
		} else {
			var cardthongbao = '';
		}
		if (list_noti !== "") {
			var cardthongbao_first = (
				<Fragment>
					{
						list_noti.map(function(v, i) {
							if (i === 0) {
								return (
									<div className="card card-cus card-icon lift lift-sm" href="knowledge-base-category.html" style={{"marginBottom": "40px", "marginTop": "0px", "marginLeft": "0px", "marginRight": "0px"}}>
										<div className="row g-0">
											<div className={"col-auto card-icon-aside" + (i == 0 ? " bg-primary" : " bg-teal")} style={{"borderRadius": "0.35rem 0px 0px 0.35rem"}}>
												<FaNewspaper style={{"color": "#fff"}} />
											</div>
											<div className="col">
												<div className="card-body py-5" style={{whiteSpace: "pre-wrap"}}>
													<h5 className={"card-title mb-2" + (i == 0 ? " text-primary" : " text-teal")} style={{"lineBreak": "anywhere"}}>{ Buffer.from(v.title, 'base64').toString('utf8') }</h5>
													<p className="card-text mb-1" style={{"lineBreak": "anywhere"}}>{ Buffer.from(v.content, 'base64').toString('utf8') }</p>
													<div className="small text-muted"><Moment format="Ngày DD/MM/YYYY">{v.create_at * 1000}</Moment></div>
												</div>
											</div>
										</div>
									</div>
								);
							} else {
								return ('');
							}
						})
					}
				</Fragment>
			);
		} else {
			var cardthongbao_first = '';
		}
		if (topaccount !== "") {
			var cardtopaacount = (
				<Fragment>
					{
						topaccount.map(function(v, i) {
							if (i <= 10) {
								return (
									<div className="d-flex align-items-center justify-content-between mb-4">
										<div className="d-flex align-items-center flex-shrink-0 me-3">
											<div className="avatar avatar-xl me-3 bg-gray-200"><img style={{"margin": "0"}} className="avatar-img img-fluid" src={process.env.PUBLIC_URL + '/images/icon/avatar.jpg'} alt=""/></div>
											<div className="d-flex flex-column fw-bold">
												<a className="text-dark line-height-normal mb-1" href="#!">{v.username}</a>
												<div className="small text-muted line-height-normal"><NumberFormat value={ v.tien_nap } displayType={'text'} thousandSeparator={true} suffix={' coin'} /></div>
											</div>
										</div>
										<div className="dropdown no-caret">
											<button className="btn btn-transparent-dark btn-icon-bar-user" id="dropdownPeople1" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-more-vertical">
													<circle cx="12" cy="12" r="1"></circle>
													<circle cx="12" cy="5" r="1"></circle>
													<circle cx="12" cy="19" r="1"></circle>
												</svg>
											</button>
										</div>
									</div>
								);
							} else {
								return ('');
							}
						})
					}
				</Fragment>
			);
		} else {
			var cardtopaacount = '';
		}
		const date = new Date();
    	return (
    		<Fragment>
	    		<div className="row" data-toggle="appear" >
			    	<div className="col-md-12 w-100">
			    		<div style={{"background": "transparent"}} className="block">
			    			<div className="block-content-cus block-content tab-content overflow-hidden">
								<div className="d-flex justify-content-between align-items-sm-center flex-column flex-sm-row mb-4">
									<div className="me-4 mb-3 mb-sm-0">
										<h1 className="mb-0">Dashboard</h1>
										<div className="small">
											<span className="fw-500 text-primary"><Moment format="dddd">{date}</Moment></span> · <Moment format="MMMM DD YYYY, HH:mm A">{date}</Moment>
										</div>
									</div>
								</div>
								<div className="card card-waves mb-4 mt-5">
									<div className="card-body p-5">
										<div className="row align-items-center justify-content-between">
											<div className="col">
												<h2 className="text-primary" style={{"textTransform": "capitalize"}}>Chào mừng bạn đến với {domainSite}</h2>
												{cardthongbao_first}
												<a className="btn btn-primary " href="/naptien" style={{"width": "200px"}}>
													Nạp Ngay  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-right ms-1">
													<line x1="5" y1="12" x2="19" y2="12"></line>
													<polyline points="12 5 19 12 12 19"></polyline>
												</svg>
												</a>
											</div>
											<div className="col d-none d-lg-block mt-xxl-n4">
												<svg
												  id="prefix__Layer_1"
												  xmlns="http://www.w3.org/2000/svg"
												  x={0}
												  y={0}
												  viewBox="0 0 605.7 364.2"
												  xmlSpace="preserve"
												>
												  <style>
													{
													  ".prefix__st0{fill:#263238}.prefix__st1{fill:#0061f2}.prefix__st2{opacity:.2}.prefix__st3{fill:#fff}.prefix__st4{fill:#e6e6e6}.prefix__st5{fill:#e0e0e0}.prefix__st6{opacity:.1}.prefix__st7{fill:#455a64}.prefix__st8{fill:#e5baab}.prefix__st9{fill:#d78776}"
													}
												  </style>
												  <path
													className="prefix__st0"
													d="M605.7 363.2c0 .1-135.6.3-302.8.3S0 363.4 0 363.2s135.6-.3 302.9-.3 302.8.2 302.8.3z"
													id="prefix__freepik--Floor--inject-499"
												  />
												  <g id="prefix__freepik--Plant--inject-499">
													<path
													  className="prefix__st1"
													  d="M62.3 332.2c-3.6-1.7-7.7-2.2-11.6-1.4-2.1.4-4.3 1-5.7 2.6s-1.7 4.4-.1 5.7c1.1.7 2.3 1 3.6.9 3.1 0 6.5-.6 8.9 1.3 1.4 1 2.3 2.8 4 3.3 1.7.4 3.5-.4 4.4-1.9.8-1.5 1-3.3.5-5-.4-2.4-1.9-4.4-4-5.5zM70.4 316.6c-2.2 3.1-6.4 2.1-8.3.2s-2.8-4.6-3.5-7.2c-1.7-6-3.4-12.2-2.2-18.2.3-1.9 1.1-3.6 2.3-5 1.2-1.4 3.2-2 5-1.7 2.1.5 3.4 2.6 4.4 4.6 2.8 5.8 4.3 12.2 4.3 18.7 0 2.9-.3 6.1-2 8.6"
													/>
													<path d="M70.4 316.6c-2.2 3.1-6.4 2.1-8.3.2s-2.8-4.6-3.5-7.2c-1.7-6-3.4-12.2-2.2-18.2.3-1.9 1.1-3.6 2.3-5 1.2-1.4 3.2-2 5-1.7 2.1.5 3.4 2.6 4.4 4.6 2.8 5.8 4.3 12.2 4.3 18.7 0 2.9-.3 6.1-2 8.6" />
													<path
													  className="prefix__st1"
													  d="M76.3 321c-2.3-2.9-2.9-6.8-1.7-10.3 1.2-3.5 3.3-6.5 6.1-8.9 3.2-2.9 6.9-5.1 11-6.5 1.6-.6 3.2-.9 4.9-.8 1.7.1 3.2 1 4.1 2.5 1.2 2.2.1 4.9-1.1 7-2.1 3.9-4.5 7.5-7.2 11-2.1 2.8-4.6 5.5-7.9 6.8s-6.7 1.1-8.4-1.2"
													/>
													<path
													  className="prefix__st0"
													  d="M70.5 363.1c-.1-.5-.2-.9-.2-1.4-.1-1-.2-2.3-.4-3.8s-.4-3.5-.9-5.6c-.5-2.3-1.2-4.5-2-6.6-.8-2.2-2-4.2-3.4-6-1.1-1.5-2.6-2.7-4.3-3.6-1.1-.6-2.4-.9-3.6-1.1-.5 0-.9-.1-1.4-.2.5-.1.9-.1 1.4 0 1.3.1 2.6.4 3.8 1 1.8.8 3.3 2.1 4.5 3.6 1.5 1.9 2.6 3.9 3.5 6.1.9 2.2 1.5 4.4 2 6.7.4 1.9.6 3.8.7 5.7.1 1.6.2 2.9.2 3.9.2.4.2.9.1 1.3z"
													/>
													<path
													  className="prefix__st0"
													  d="M70.3 360.2v-.6-1.9c0-1.6 0-4-.1-6.8-.1-5.8-.6-13.7-1.6-22.5s-2.2-16.6-3.4-22.3c-.3-1.4-.6-2.7-.8-3.8s-.5-2.1-.7-2.9-.3-1.3-.4-1.8c-.1-.2-.1-.4-.1-.6.1.2.2.4.2.6l.5 1.8c.2.8.5 1.7.8 2.9s.6 2.4.9 3.8c1.6 7.4 2.8 14.8 3.6 22.3 1 8.8 1.4 16.8 1.4 22.5 0 2.9 0 5.2-.1 6.9 0 .8-.1 1.4-.1 1.9 0 .1-.1.3-.1.5z"
													/>
													<path
													  className="prefix__st0"
													  d="M70.2 344.8c-.1-.6-.1-1.3 0-2 .1-1.2.2-3 .6-5.3.4-2.6 1-5.1 1.7-7.7.9-3.1 1.9-6.1 3.2-9.1 2.2-5.4 5.4-10.4 9.4-14.7.7-.7 1.4-1.4 2.2-2.1.3-.3.6-.6.9-.8l.9-.6c.5-.4 1.1-.7 1.6-1-1.9 1.5-3.7 3.1-5.4 4.8-3.9 4.3-7 9.3-9.2 14.6-1.3 2.9-2.3 5.9-3.2 9-.8 2.8-1.4 5.4-1.8 7.6s-.6 4-.8 5.2c.1.8.1 1.5-.1 2.1z"
													/>
												  </g>
												  <g id="prefix__freepik--Windows--inject-499">
													<path className="prefix__st3" d="M149.4 19.5h307.4v239.2H149.4z" />
													<path
													  className="prefix__st0"
													  d="M456.7 258.7c0-1.8-.1-94.8-.2-239.2l.2.2H149.4l.3-.3v239.2l-.2-.2 307.2.3-307.3.2h-.2v-.2V19.2H457v.2c-.1 144.5-.3 237.5-.3 239.3z"
													/>
													<path
													  className="prefix__st0"
													  d="M233.9 238.6c-.1 0-.3-26-.3-58.1s.1-58.1.3-58.1.3 26 .3 58.1-.2 58.1-.3 58.1zM367.3 238.6c-.1 0-.3-26-.3-58.1s.1-58.1.3-58.1.3 26 .3 58.1-.2 58.1-.3 58.1zM279.4 238.6c-.1 0-.3-33.2-.3-74.2s.1-74.2.3-74.2.3 33.2.3 74.2-.1 74.2-.3 74.2zM187.1 238.6c-.1 0-.3-33.2-.3-74.2s.1-74.2.3-74.2.3 33.2.3 74.2-.2 74.2-.3 74.2zM419.6 238.6c-.1 0-.3-33.2-.3-74.2s.1-74.2.3-74.2.3 33.2.3 74.2-.1 74.2-.3 74.2zM319.3 238.6c-.1 0-.3-38.4-.3-85.7s.1-85.7.3-85.7.3 38.4.3 85.7-.1 85.7-.3 85.7z"
													/>
													<path
													  className="prefix__st0"
													  d="M235 122.5c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1 0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1z"
													/>
													<circle className="prefix__st0" cx={279.4} cy={90.1} r={1.1} />
													<path
													  className="prefix__st0"
													  d="M279.4 94c-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8 0 2-1.7 3.7-3.8 3.8zm0-7.4c-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6 3.6-1.6 3.6-3.6-1.6-3.6-3.6-3.6z"
													/>
													<circle className="prefix__st0" cx={319.3} cy={67.2} r={1.1} />
													<circle className="prefix__st0" cx={367.3} cy={123.5} r={1.1} />
													<circle className="prefix__st0" cx={419.6} cy={90.1} r={1.1} />
													<path
													  className="prefix__st0"
													  d="M188.2 91.2c0 .6-.5 1.1-1.1 1.1-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1c.6 0 1.1.5 1.1 1.1z"
													/>
													<path
													  className="prefix__st1"
													  d="M429.9 142.7l-.9.3c-.8.2-1.7.5-2.5.9-3 1.4-5.7 3.5-7.9 6-3 3.2-6 7.7-9.7 12.7-2 2.7-4.2 5.3-6.6 7.6-1.3 1.3-2.8 2.5-4.3 3.5-1.6 1.1-3.3 2-5.1 2.8-3.9 1.6-8.1 2.3-12.3 2.1-2.2 0-4.5-.3-6.6-.8-2.3-.5-4.5-1.5-6.4-2.8-2-1.4-3.7-3.2-5-5.2-1.4-2-2.6-4.1-3.8-6.3-2.4-4.3-4.9-8.7-7.7-13.1s-5.4-9.1-8.2-13.7c-2.8-4.7-6.2-9.1-10.1-13-2-1.9-4.3-3.6-6.8-4.8-2.5-1.3-5.2-2.1-8-2.4-5.8-.6-11.6.7-16.6 3.6-5 3-9.3 7-12.7 11.8-3.3 4.7-6.4 9.5-9.1 14.6-2.7 4.9-5.6 9.7-8.8 14.3-3.1 4.4-6.6 8.5-10.6 12.1-1 .9-2 1.7-3.1 2.5-1 .8-2.1 1.5-3.3 2.1-2.2 1.3-4.6 2.3-7.1 2.9-1.2.3-2.5.6-3.7.7-.6.1-1.2.1-1.9.1h-1.9c-2.4-.1-4.8-.6-7.1-1.3-4.3-1.5-8.3-3.6-12-6.3-3.6-2.5-6.8-5-10-7.3-3-2.2-6.1-4.2-9.5-5.8-3-1.4-6.2-2.3-9.5-2.7-2.8-.3-5.7-.2-8.5.5l-1.8.6c-.6.2-1.2.4-1.7.7-1 .5-2 1-3 1.7-1.6 1.1-3.1 2.3-4.5 3.6l-1.6 1.7c-.5.5-.9 1-1.3 1.5l-1.6 2.1c-.2.2-.4.5-.6.7.1-.3.3-.5.5-.8l1.5-2.2 1.2-1.5 1.5-1.8c1.4-1.4 2.9-2.7 4.5-3.8 1-.7 2-1.3 3-1.8.6-.3 1.1-.5 1.8-.7.6-.3 1.2-.5 1.9-.6 2.9-.8 5.8-1 8.8-.7 3.4.4 6.7 1.3 9.8 2.6 3.4 1.6 6.7 3.5 9.7 5.8 3.2 2.3 6.5 4.8 10 7.2 3.6 2.5 7.5 4.6 11.7 6 2.2.7 4.5 1.1 6.8 1.2h1.8c.6 0 1.2 0 1.8-.1 1.2-.1 2.4-.4 3.5-.7 4.8-1.4 9.2-3.8 12.9-7.2 3.9-3.6 7.4-7.5 10.4-11.9 3.2-4.6 6-9.3 8.7-14.1 2.7-5.1 5.8-10 9.1-14.8 3.5-5 8-9.1 13.2-12.3 2.7-1.5 5.6-2.6 8.6-3.2 3-.6 6-.8 9-.5 3 .3 5.9 1.2 8.6 2.5 2.6 1.3 5 3.1 7.1 5.1 4 4 7.4 8.5 10.3 13.3 2.9 4.6 5.4 9.3 8.2 13.7 2.7 4.4 5.3 8.9 7.7 13.2s4.7 8.5 8.4 11.1c1.8 1.3 3.8 2.2 6 2.7 2.1.5 4.2.8 6.4.8 4 .2 8.1-.4 11.9-1.9 1.7-.7 3.4-1.6 5-2.7 1.5-1 2.9-2.2 4.2-3.4 2.4-2.3 4.6-4.8 6.6-7.5 3.8-5 6.9-9.4 9.9-12.6 2.3-2.6 5.1-4.6 8.3-5.9.8-.3 1.7-.6 2.5-.7.1.1.3 0 .6 0z"
													/>
													<path
													  className="prefix__st0"
													  d="M186 46.3h53.6v3H186zM186 53.3h26.5v3H186zM153.5 0h298.7c2.5 0 4.5 2 4.5 4.5v15H149v-15c0-2.5 2-4.5 4.5-4.5z"
													/>
													<path
													  className="prefix__st3"
													  d="M164.9 10.1c0 1.2-.9 2.1-2.1 2.1-1.2 0-2.1-.9-2.1-2.1 0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1zM174.1 10.1c0 1.2-.9 2.1-2.1 2.1-1.2 0-2.1-.9-2.1-2.1 0-1.2.9-2.1 2.1-2.1 1.2 0 2.1 1 2.1 2.1zM183.3 10.1c0 1.2-.9 2.1-2.1 2.1-1.2 0-2.1-.9-2.1-2.1 0-1.2.9-2.1 2.1-2.1 1.1 0 2.1 1 2.1 2.1z"
													/>
													<path
													  className="prefix__st4"
													  d="M34.1 160.2h119.7c1.8 0 3.2 1.4 3.2 3.2v28.9c0 1.8-1.4 3.2-3.2 3.2H34.1c-1.8 0-3.2-1.4-3.2-3.2v-28.9c-.1-1.7 1.4-3.2 3.2-3.2z"
													/>
													<path
													  className="prefix__st3"
													  d="M57.4 183.8c-2.7 3.3-7.5 3.8-10.8 1.2-3.3-2.7-3.8-7.5-1.2-10.8 2.7-3.3 7.5-3.8 10.8-1.2 3.3 2.7 3.9 7.5 1.2 10.8z"
													/>
													<path
													  className="prefix__st0"
													  d="M55.8 176.4c-1.3 1.6-2.7 3.1-4.2 4.4l-1 1-.2.2-.2-.2c-1.1-1.1-2.2-2.2-3.1-3.5 1.3.9 2.4 2 3.5 3.1h-.3l1-1c1.3-1.4 2.8-2.8 4.5-4zM144.7 175.4c0 .1-16 .3-35.8.3s-35.8-.1-35.8-.3 16-.3 35.8-.3 35.8.1 35.8.3zM115.3 182.4c0 .1-9.3.3-20.7.3s-20.8-.1-20.8-.3 9.3-.3 20.7-.3 20.8.1 20.8.3z"
													/>
													<path
													  className="prefix__st5"
													  d="M70.7 75h119.2c1.4 0 2.6 1.2 2.6 2.6V124c0 1.4-1.2 2.6-2.6 2.6H70.7c-1.4 0-2.6-1.2-2.6-2.6V77.6c0-1.4 1.1-2.6 2.6-2.6z"
													/>
													<path
													  className="prefix__st1"
													  d="M93.9 91.3c0 3.2-2.6 5.8-5.8 5.8s-5.8-2.6-5.8-5.8c0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8zM99.7 87.3h40.4v2.2H99.7z"
													/>
													<path className="prefix__st3" d="M99.7 92.4h78.6v2.2H99.7z" />
													<path
													  className="prefix__st1"
													  d="M93.9 109.2c0 3.2-2.6 5.8-5.8 5.8s-5.8-2.6-5.8-5.8c0-3.2 2.6-5.8 5.8-5.8 3.2-.1 5.8 2.5 5.8 5.8 0-.1 0-.1 0 0zM99.7 105.2h20.6v2.2H99.7z"
													/>
													<path className="prefix__st3" d="M99.7 110.2h78.6v2.2H99.7z" />
													<path
													  className="prefix__st5"
													  d="M94 210.9h152.6c2.2 0 4 1.8 4 4v60.3c0 2.2-1.8 4-4 4H94c-2.2 0-4-1.8-4-4v-60.3c0-2.2 1.8-4 4-4z"
													/>
													<path
													  className="prefix__st1"
													  d="M119.4 243.9l-.1-13.8c-4.2.1-8.3 1.7-11.4 4.5-4.1 3.6-6.2 8.9-5.5 14.3.1.7.2 1.3.3 2l16.7-3.8v-3.2zM136.6 239.6c-2.5-5.3-7.6-8.9-13.5-9.4H121.2l.1 13.8v3.2l16.7 3.6c.3-1.2.4-2.4.4-3.6-.1-2.6-.7-5.2-1.8-7.6z"
													/>
													<path d="M136.6 239.6c-2.5-5.3-7.6-8.9-13.5-9.4H121.2l.1 13.8v3.2l16.7 3.6c.3-1.2.4-2.4.4-3.6-.1-2.6-.7-5.2-1.8-7.6z" />
													<path
													  className="prefix__st1"
													  d="M120.3 248.8l-16.7 3.8c2.1 9.2 11.2 15 20.5 12.9 6.5-1.5 11.5-6.5 12.9-13l-16.7-3.7"
													/>
													<path d="M120.3 248.8l-16.7 3.8c2.1 9.2 11.2 15 20.5 12.9 6.5-1.5 11.5-6.5 12.9-13l-16.7-3.7" />
													<path
													  className="prefix__st3"
													  d="M149.5 234.1h84.7v3.8h-84.7zM149.5 244.3h84.7v3.8h-84.7zM149.5 255.5h45.8v3.8h-45.8z"
													/>
													<path
													  className="prefix__st4"
													  d="M285.5 162.5h150.6c4.6 0 8.4 3.8 8.4 8.4v144.4c0 4.6-3.8 8.4-8.4 8.4H285.5c-4.6 0-8.4-3.8-8.4-8.4V170.9c0-4.6 3.8-8.4 8.4-8.4z"
													/>
													<path
													  className="prefix__st0"
													  d="M288.8 272.9h5.5v1.6h-5.5zM301.3 281.4h7v1.6h-7zM325.7 281.4h7v1.6h-7zM350.2 281.4h7v1.6h-7zM374.6 281.4h7v1.6h-7zM399.1 281.4h7v1.6h-7zM423.6 281.4h7v1.6h-7zM288.8 251.8h5.5v1.6h-5.5zM288.8 212h5.5v1.6h-5.5zM288.8 192h5.5v1.6h-5.5zM289.1 231.9h5.5v1.6h-5.5zM430.4 274.5H421.5l-24.5.1-80.7.1h-19.4v-.2c0-27 .1-50.7.1-67.7 0-8.5.1-15.3.1-20v-5.4-1.4-.5V186.8c0 4.7 0 11.5.1 20 0 17 0 40.8.1 67.7l-.3-.3h19.1l80.7.1 24.5.1H429.6l.8.1z"
													/>
													<path
													  className="prefix__st0"
													  d="M431.9 232.6c0 .1-29 .3-64.7.3s-64.7-.1-64.7-.3 29-.3 64.7-.3 64.7.2 64.7.3zM431.9 212.8c0 .1-29 .3-64.7.3s-64.7-.1-64.7-.3 29-.3 64.7-.3 64.7.1 64.7.3zM431.9 192.8c0 .1-29 .3-64.7.3s-64.7-.1-64.7-.3 29-.3 64.7-.3 64.7.1 64.7.3zM431.9 252.6c0 .1-29 .3-64.7.3s-64.7-.1-64.7-.3 29-.3 64.7-.3 64.7.1 64.7.3z"
													/>
													<path
													  className="prefix__st1"
													  d="M303.9 270.2v-17.6l11-17.1 7.5 5.7 15.3-23.8 9 6.4 12.6-22 10.2 8.3 15.3-29.1 16.5 32.6 13.4-16.3 15.7-4.5v77.4H303.9z"
													/>
													<path
													  className="prefix__st0"
													  d="M431.9 186.5H427.6l-12.1.1h.1l-12.9 16.9-.1.1h-32.5l.2-.1-13.6 22.7-13.4 22.2-.2.3-.2-.3-17.5-24.1h.4l-16 24.9c-1.9 3-3.4 5.3-4.5 6.9-.5.8-.9 1.4-1.2 1.8s-.4.6-.4.6.1-.2.4-.6.6-1 1.1-1.8l4.4-7 15.8-25 .2-.3.2.2c5.2 7.2 11.2 15.3 17.6 24.1h-.4l13.3-22.2 13.6-22.6.1-.1h32.5l-.2.1 13-16.8v-.1h.1l12.1.1h4.4z"
													/>
													<path
													  className="prefix__st0"
													  d="M331 229.8c0 .7-.5 1.3-1.2 1.3s-1.3-.5-1.3-1.2.5-1.3 1.2-1.3 1.3.5 1.3 1.2zM368.4 208.6c0 .7-.5 1.3-1.2 1.3s-1.3-.5-1.3-1.2.5-1.3 1.2-1.3c.7-.1 1.2.5 1.3 1.2zM397.4 203.4c0 .7-.5 1.3-1.2 1.3s-1.3-.5-1.3-1.2.5-1.3 1.2-1.3h.1c.6-.1 1.2.5 1.2 1.2 0-.1 0-.1 0 0z"
													/>
													<ellipse
													  className="prefix__st3"
													  cx={309.3}
													  cy={302.5}
													  rx={8}
													  ry={7.7}
													/>
													<path
													  className="prefix__st3"
													  d="M329.2 297.3h94.3v2.9h-94.3zM329.2 304.6h39.2v2.9h-39.2z"
													/>
													<path
													  className="prefix__st4"
													  d="M395.6 37.3h101.3c2.7 0 4.9 2.2 4.9 4.9v82.3c0 2.7-2.2 4.9-4.9 4.9H395.6c-2.7 0-4.9-2.2-4.9-4.9V42.2c-.1-2.7 2.2-4.9 4.9-4.9z"
													/>
													<path
													  className="prefix__st1"
													  d="M410 74.2h6v45.2h-6zM437.3 70.5h6v48.9h-6zM465.5 64.3h6v55.1h-6zM452.2 97.4h6v22h-6z"
													/>
													<path d="M452.2 97.4h6v22h-6z" />
													<path className="prefix__st1" d="M417 69.4h6v50.1h-6z" />
													<path d="M417 69.4h6v50.1h-6z" />
													<path className="prefix__st1" d="M444.7 58.9h6v60.6h-6z" />
													<path d="M444.7 58.9h6v60.6h-6z" />
													<path className="prefix__st1" d="M480.9 58.9h6v60.6h-6z" />
													<path d="M480.9 58.9h6v60.6h-6z" />
													<path className="prefix__st1" d="M473.1 46.9h6v72.5h-6z" />
													<path d="M473.1 46.9h6v72.5h-6z" />
													<path className="prefix__st1" d="M424.4 87.7h6v31.8h-6z" />
													<path d="M424.4 87.7h6v31.8h-6z" />
													<path
													  className="prefix__st0"
													  d="M495.5 122.2c0 .1-21.4.3-47.7.3s-47.8-.1-47.8-.3 21.4-.3 47.8-.3 47.7.1 47.7.3zM397.2 111.4h3.7v1.2h-3.7zM397.2 95.3h3.7v1.2h-3.7zM397.2 65h3.7v1.2h-3.7zM397.2 49.8h3.7V51h-3.7zM397.4 80.2h3.7v1.2h-3.7z"
													/>
													<path
													  className="prefix__st1"
													  d="M265.9 29.8h107.5c1.8 0 3.2 1.4 3.2 3.2v25.5c0 1.8-1.4 3.2-3.2 3.2H265.9c-1.8 0-3.2-1.4-3.2-3.2V33.1c0-1.8 1.4-3.3 3.2-3.3z"
													/>
													<path
													  className="prefix__st3"
													  d="M286.7 51.1c-2.4 3-6.8 3.5-9.8 1.1s-3.5-6.8-1.1-9.8c2.4-3 6.8-3.5 9.8-1.1 3 2.5 3.5 6.8 1.1 9.8z"
													/>
													<path
													  className="prefix__st0"
													  d="M281.3 53.8c-3.9-.2-6.8-3.5-6.6-7.4.2-3.3 2.6-6 5.9-6.5h.8c3.9 0 7 3.2 6.9 7.1 0 1.5-.5 3-1.5 4.3-1.2 1.4-2.8 2.4-4.7 2.6-.3-.1-.6-.1-.8-.1zm0-13.9h-.8c-3.8.4-6.5 3.8-6.1 7.6.4 3.8 3.8 6.5 7.6 6.1 1.8-.2 3.5-1.1 4.6-2.5 2.4-3 1.9-7.3-1.1-9.7-1.1-1-2.7-1.5-4.2-1.5z"
													/>
													<path
													  className="prefix__st1"
													  d="M285.2 44.4c-1.1 1.5-2.4 2.8-3.7 4l-.9.9-.2.2-.2-.2c-1-1-2-2-2.8-3.1 1.1.8 2.2 1.8 3.1 2.8h-.4l.9-.9c1.3-1.4 2.7-2.6 4.2-3.7z"
													/>
													<path
													  className="prefix__st3"
													  d="M365.5 43.5c0 .1-14.5.3-32.4.3s-32.4-.1-32.4-.3 14.5-.3 32.4-.3 32.4.1 32.4.3zM339 49.8c0 .1-8.4.3-18.7.3s-18.7-.1-18.7-.3 8.4-.3 18.7-.3 18.7.1 18.7.3z"
													/>
												  </g>
												  <g id="prefix__freepik--speech-bubble--inject-499">
													<path
													  className="prefix__st0"
													  d="M551.5 90.6s-.1.2-.4.5c-.3.3-.7.8-1.3 1.4-1.7 1.6-3.7 3-5.8 4-.7.4-1.5.7-2.2 1l-1.2.4-1.3.4c-.9.2-1.9.4-2.8.5-.5.1-1 .1-1.5.1h-1.6c-4.9 0-9.7-1.6-13.7-4.4h.2L508 96.9l-.7.1.5-.5 6.5-7.5v.3c-1.2-1.6-2.2-3.4-2.9-5.2-.8-1.9-1.3-3.9-1.6-6-.6-4.3.1-8.7 1.8-12.7 4.5-10.2 15.4-16 26.4-14 4.6.9 8.9 3.1 12.3 6.4 7.5 7.1 9.4 18.3 4.9 27.6-.2.5-.5.9-.7 1.3s-.5.8-.7 1.1c-.3.6-.7 1.1-1.2 1.7l-.8 1c-.1 0-.2.1-.3.1.1 0 .1-.2.2-.3l.8-1c.4-.5.8-1.1 1.1-1.7.2-.3.4-.7.7-1.1s.4-.9.6-1.3c2.5-5.3 2.9-11.4 1.2-17-1.2-3.9-3.3-7.4-6.2-10.1-1.6-1.6-3.4-2.9-5.4-3.9-2.1-1.1-4.4-1.9-6.7-2.3-12.8-2.3-25.1 6.1-27.4 18.9-.4 2.4-.5 4.8-.2 7.3.3 2 .8 4 1.5 5.9.8 1.8 1.7 3.5 2.9 5.1l.1.2-.1.1-6.6 7.4-.2-.4 11.9-2.2h.2c3.9 2.8 8.6 4.3 13.4 4.4h1.6c.5 0 1 0 1.5-.1.9-.1 1.9-.3 2.8-.5l1.3-.3 1.2-.4c.8-.3 1.5-.6 2.2-.9 2.1-1 4.1-2.3 5.8-3.9l1.3-1.3c.4-.5.5-.6.5-.6z"
													/>
													<path
													  className="prefix__st0"
													  d="M533.8 70l-4-1.3-4-1.4.9 4.2.8 4.1 2.2-1.9 9.4 10.6 2-1.8-9.4-10.5z"
													/>
												  </g>
												  <g id="prefix__freepik--character-2--inject-499">
													<path
													  className="prefix__st1"
													  d="M514.4 348.6l-6.5-6.5 12.1-12.2 9.6 9.4-.7.8c-3.2 3.6-16.3 17.9-19.2 19.4-3.3 1.8 4.7-10.9 4.7-10.9z"
													/>
													<path
													  className="prefix__st0"
													  d="M525.1 343.6c-.8-1.2-1.2-2.7-1.1-4.1.2-1.4.8-2.8 1.9-3.7l3.4 3.4-4.2 4.4z"
													/>
													<path
													  className="prefix__st0"
													  d="M510.7 355s-2.6 4.7-1.5 4.8 14.9-13.8 20.4-20.5l-.3-.2-16 16.4c0-.1-1.9-1.2-2.6-.5z"
													/>
													<path
													  className="prefix__st7"
													  d="M529.4 338.8c-.1.1-.1.2-.2.2l-.6.6-2.1 2.3c-1.8 1.9-4.3 4.6-7.1 7.5-2.8 2.9-5.4 5.4-7.4 7.2l-2.2 2.1-.6.6-.2.2.2-.2.6-.6 2.3-2.2c1.9-1.8 4.5-4.4 7.3-7.3 2.8-2.9 5.3-5.5 7.2-7.4l2.2-2.3.6-.6c-.1 0 0 0 0-.1z"
													/>
													<path
													  className="prefix__st7"
													  d="M513.5 355.6c-.5-.3-1-.5-1.5-.6-.5-.1-1.1-.1-1.6-.1.5-.2 1.1-.3 1.6-.1.6.1 1.1.4 1.5.8zM515.2 350.2c-.3 0-.6 0-.8-.1-.3 0-.6-.1-.8-.3 0-.1.4 0 .8.1s.8.2.8.3zM515.7 348.7c0 .1-.3.1-.7.1-.2 0-.5 0-.7-.1 0-.1.3-.1.7-.1s.7 0 .7.1zM515.2 346.9s-.2.4-.6.7-.7.6-.7.6.2-.4.5-.7c.2-.2.5-.4.8-.6zM514.6 345.9c-.1.3-.2.7-.5.9-.2.3-.5.5-.8.6 0 0 .3-.4.7-.8s.5-.7.6-.7z"
													/>
													<path
													  className="prefix__st7"
													  d="M513.8 349.6c-.2.3-.5.6-.8.8-.3.2-.6.5-1 .6-.2.1-.4.2-.7.3-.1.1-.3.1-.4 0-.1-.1-.2-.3-.2-.4.3-.9 1.2-1.5 2.2-1.4.3 0 .5.1.8.3.2.1.2.2.2.2-.3-.2-.6-.3-1-.3s-.8.1-1.1.2c-.4.2-.7.6-.9 1 0 .2.2.3.4.2l.6-.3c.3-.2.7-.4 1-.6.5-.4.8-.7.9-.6z"
													/>
													<path
													  className="prefix__st7"
													  d="M513.6 349.8s-.3-.1-.6-.5c-.2-.2-.3-.5-.4-.8-.1-.4 0-.7.2-1 .2-.1.5-.1.6.1.1.1.2.3.2.5.1.3.1.6.1.8.1.4.1.6-.1.9v-.8c0-.3-.1-.5-.2-.8-.1-.3-.3-.6-.5-.5-.2.2-.3.6-.2.9 0 .3.1.5.3.7.3.2.4.3.6.5zM525.8 335.8s-.4.3-.9.9c-1.3 1.6-1.5 3.9-.6 5.7.3.7.7 1.1.7 1.1l-.2-.2c-.2-.2-.4-.5-.5-.8-1-1.9-.8-4.2.6-5.9.2-.2.4-.5.7-.7 0 0 .1-.1.2-.1zM519.5 332c.9.7 1.8 1.5 2.6 2.4.9.8 1.7 1.6 2.5 2.5-.9-.7-1.8-1.5-2.6-2.4-.9-.8-1.7-1.6-2.5-2.5zM522.4 344c-.4.7-1 1.4-1.6 2-.6.6-1.2 1.2-1.9 1.6l1.8-1.8c.9-1 1.6-1.9 1.7-1.8z"
													/>
													<path
													  className="prefix__st7"
													  d="M524.7 341.6c.1 0 .1.2.2.5s.2.5.2.5-.3-.1-.4-.4 0-.6 0-.6zM524.5 339.6c.1 0 .1.2.1.5s0 .5-.1.5-.1-.2-.1-.5 0-.5.1-.5zM525.3 337.8s-.1.2-.2.5-.1.5-.2.5-.1-.3 0-.6.3-.5.4-.4zM525.9 336.6v.3c0 .2-.2.2-.2.2v-.3c0-.2.1-.2.2-.2z"
													/>
													<path
													  className="prefix__st1"
													  d="M464.9 359.3l.2-9.2 17.2.3-.2 13.4H481c-4.7.2-24.2.6-27.3-.5-3.5-.9 11.2-4 11.2-4z"
													/>
													<path
													  className="prefix__st0"
													  d="M475.9 363.6c.3-1.4 1.1-2.7 2.3-3.6 1.1-.9 2.6-1.3 4-1.2l-.1 4.8h-6.2z"
													/>
													<path
													  className="prefix__st0"
													  d="M457.7 361.1s-5.2 1.4-4.5 2.2 20.2 1.2 28.9.6v-.4l-22.9-.2s-.5-2.2-1.5-2.2z"
													/>
													<path
													  className="prefix__st7"
													  d="M482.3 363.5h-1.1l-3.1.1c-2.6 0-6.3.1-10.3 0s-7.7-.2-10.3-.3l-3.1-.2-.8-.1h-.3 1.1l3.1.1c2.6.1 6.3.2 10.3.3s7.7.1 10.3 0h4s.1.1.2.1z"
													/>
													<path
													  className="prefix__st7"
													  d="M459.1 363.6c-.2-1.1-.8-2-1.6-2.7.5.2 1 .6 1.2 1.1.4.4.5 1 .4 1.6zM464.3 361.1s-.3-.3-.5-.7-.4-.8-.3-.8.3.3.5.7.3.7.3.8zM465.7 360.4s-.3-.1-.6-.4-.5-.5-.5-.6.3.1.6.4.5.5.5.6zM466.6 358.8c-.3.1-.6.1-.9.1-.3 0-.6 0-.9-.1.3-.1.6-.1.9-.1.3-.1.6 0 .9.1zM466.9 357.6c-.3.2-.6.3-1 .3-.3 0-.7 0-1-.1.3 0 .7-.1 1-.1.3-.1.6-.1 1-.1z"
													/>
													<path
													  className="prefix__st7"
													  d="M463.7 359.6c-.4.1-.7.1-1.1 0-.4-.1-.8-.1-1.2-.3-.2-.1-.5-.2-.7-.3-.1-.1-.2-.2-.3-.4 0-.2 0-.3.2-.4.9-.4 1.9-.2 2.5.6.2.2.3.5.3.7v.3c-.1-.3-.3-.7-.5-1-.2-.3-.6-.5-.9-.6-.4-.2-.9-.1-1.3.1-.2.1-.1.3.1.5l.6.3c.4.1.8.2 1.1.3.8.1 1.2.1 1.2.2z"
													/>
													<path
													  className="prefix__st7"
													  d="M463.4 359.6c-.1-.2-.2-.5-.1-.8 0-.3.1-.6.3-.8.2-.3.5-.5.9-.5.2 0 .4.3.3.5 0 .2-.1.3-.2.5s-.3.5-.5.7c-.1.2-.4.3-.7.4.1 0 .3-.2.6-.6.2-.2.3-.4.5-.6.2-.2.3-.6 0-.7s-.6.2-.7.5c-.2.2-.3.5-.3.7-.1.2-.1.5-.1.7zM482 358.8s-.5-.1-1.3 0c-2.1.2-3.9 1.6-4.6 3.5-.3.7-.3 1.2-.3 1.2v-.3c0-.3.1-.6.2-.9.7-2.1 2.5-3.5 4.7-3.6h.9c.3 0 .4.1.4.1zM480.4 351.6c.1 1.2.1 2.4.1 3.5 0 1.2 0 2.4-.1 3.5-.1-1.2-.1-2.4-.1-3.5-.1-1.2 0-2.3.1-3.5zM473.7 361.9c-.8.2-1.7.2-2.5.2s-1.7-.1-2.5-.2c0-.1 1.1 0 2.5 0h2.5z"
													/>
													<path
													  className="prefix__st7"
													  d="M477.1 362s-.1.2-.2.5-.2.5-.2.5-.1-.3 0-.6.3-.5.4-.4zM478.4 360.4l-.2.4c-.1.2-.4.3-.4.2s.1-.2.2-.4.3-.2.4-.2zM480.2 359.7c0 .1-.2 0-.5.1s-.4.2-.5.2.1-.3.4-.4.6.1.6.1zM481.5 359.4c0 .1-.1.1-.2.2s-.3 0-.3 0l.2-.2c.1-.1.3 0 .3 0z"
													/>
													<path
													  className="prefix__st8"
													  d="M474 162.7c-6.4 18.8-17.8 52.9-17.8 52.9-1.5.9-3.1 1.7-4.8 2.3-1.1.3-2.3.4-3.5.4-.6-.1-1.2.2-1.3.8-.1.3 0 .7.2.9.7.7 3.7 1.2 7 .2s.9 4.1-.2 5.7-4.2 7.2-4 7.9c.4 1.1 1.7.6 2.8-1.1s4.2-6.6 4.7-6.4c.9.5-4.6 9.2-4.6 9.2s-1.3 1.5-.3 2.3c1.8 1.4 7.1-8 7.6-9 .3-.6.8-.1.4.5s-5.1 8.4-3.7 9.2 4.7-6.8 6.1-8.2c1.5-1.6-3.1 6.4-1.7 7.4.5.4.9.6 3.2-4.1 2-4.5 3.7-9.2 5.2-13.9 4.9-9.8 18.9-40.2 23.6-60.8"
													/>
													<path
													  className="prefix__st1"
													  d="M477.4 116.8s13.6-3.9 16.3 16.9c1.7 13.1 5.5 44.6 7 60.9.1 1.5-.8.9-.7 2.2.1 1.5 1.4 2.7 1.4 3.7 0 3.4-3.8 3.3-3.8 3.3l-35.6 1.7s-3.3.1-3.3-2.8c0-2.2 1.4-3.2 1.5-4.5 1.5-19.5 1.5-68.1 3.7-74.8 2.1-6.5 3.4-6.6 13.5-6.6z"
													/>
													<path
													  className="prefix__st0"
													  d="M480.1 117.8c.3.3.6.6.8.9.5.6 1.2 1.3 2 2.2s1.4 1.7 1.8 2.3c.2.3.5.6.7 1-.3-.3-.5-.6-.8-.9-.5-.6-1.1-1.4-1.8-2.3s-1.4-1.7-1.9-2.2c-.3-.4-.6-.7-.8-1z"
													/>
													<path
													  className="prefix__st0"
													  d="M481.7 117.4l-.6.3-1.6.6c-1.3.5-3.2 1.2-5.3 2s-4 1.3-5.4 1.7l-1.6.5c-.2.1-.4.1-.6.1.2-.1.4-.2.6-.2l1.6-.5c1.4-.4 3.3-1.1 5.3-1.8s3.9-1.4 5.3-1.9l1.6-.6c.3 0 .5-.1.7-.2z"
													/>
													<path
													  className="prefix__st0"
													  d="M466.9 118.8c.1 1.3.1 2.5 0 3.8-.2-1.3-.2-2.5 0-3.8z"
													/>
													<path
													  className="prefix__st5"
													  d="M491.2 124.2c0 .1-6 .1-13.5.1s-13.5 0-13.5-.1 6-.1 13.5-.1 13.5.1 13.5.1zM492.9 128.7h-1.2l-3.2-.1-10.6-.3-10.6-.2H463h4.4c2.7 0 6.5 0 10.6.1s7.9.3 10.6.4l3.2.2.9.1.2-.2zM493.4 132.6c0 .1-6.8.1-15.3.1s-15.3 0-15.3-.1 6.8-.1 15.3-.1 15.3.1 15.3.1zM494.1 136.9c0 .1-7.1.1-15.8.1s-15.8-.1-15.8-.1 7.1-.1 15.8-.1 15.8 0 15.8.1zM494.9 141.5c0 .1-7.2.1-16.2.1s-16.2 0-16.2-.1 7.2-.1 16.2-.1 16.2.1 16.2.1zM495.3 146.2s-7.4.1-16.4.1-16.4 0-16.4-.1 7.3-.1 16.4-.1 16.4.1 16.4.1zM495.9 151.2c0 .1-7.5.1-16.7.1s-16.7 0-16.7-.1 7.5-.1 16.7-.1 16.7.1 16.7.1zM496.4 155.6c0 .1-7.6.1-17 .1s-17 0-17-.1 7.6-.1 17-.1 17 0 17 .1zM497.2 160.4c0 .1-7.8.1-17.3.1s-17.3 0-17.3-.1 7.8-.1 17.3-.1 17.3 0 17.3.1zM497.6 165.1s-7.9.1-17.5.1-17.5 0-17.5-.1c0 0 7.9-.1 17.5-.1s17.5.1 17.5.1zM498.1 169.9c0 .1-8 .1-17.8.1s-17.8 0-17.8-.1 8-.1 17.8-.1 17.8 0 17.8.1zM498.7 174.6c0 .1-8.1.1-18.1.1s-18.1 0-18.1-.1 8.1-.1 18.1-.1 18.1.1 18.1.1zM499.2 179.4c0 .1-8.4.1-18.8.1s-18.8 0-18.8-.1 8.4-.1 18.8-.1 18.8.1 18.8.1zM499.7 184.2c0 .1-8.7.1-19.4.1s-19.4 0-19.4-.1 8.7-.1 19.4-.1 19.4 0 19.4.1zM500.2 189s-8.8.1-19.7.1-19.7 0-19.7-.1 8.8-.1 19.7-.1 19.7 0 19.7.1zM500.7 193.7c0 .1-8.9.1-19.9.1s-19.9 0-19.9-.1 8.9-.1 19.9-.1 19.9.1 19.9.1zM500.4 198.5c0 .1-9 0-20.1-.1s-20.1-.2-20.1-.3 9 0 20.1.1 20.1.2 20.1.3zM500.4 202.9c0 .1-9.3.2-20.8.3s-20.8.1-20.8.1 9.3-.2 20.8-.3 20.8-.2 20.8-.1z"
													/>
													<path
													  className="prefix__st1"
													  d="M473.5 180.6c2.3.3 4.6-.3 6.5-1.7 1.8-1.4 3.4-3.2 4.6-5.1 4.7-7 7.5-15.2 8.1-23.6.2-4.3.2-8.6-.1-12.9-1.1 8.4-3.2 16.6-6.3 24.4-2.6 6.6-6.3 12.7-10.9 18.1"
													/>
													<path d="M473.5 180.6c2.3.3 4.6-.3 6.5-1.7 1.8-1.4 3.4-3.2 4.6-5.1 4.7-7 7.5-15.2 8.1-23.6.2-4.3.2-8.6-.1-12.9-1.1 8.4-3.2 16.6-6.3 24.4-2.6 6.6-6.3 12.7-10.9 18.1" />
													<path
													  className="prefix__st0"
													  d="M496 184.9c-1.1 1.2-2.3 2.3-3.5 3.4-1.4 1.1-2.8 2.2-4.3 3.2-3.6 2.4-7.6 4.3-11.7 5.6-1.7.5-3.4 1-5.2 1.3-1.6.3-3.2.5-4.9.6l.3-.1 1-.1c.8-.1 2-.3 3.5-.6 1.7-.3 3.4-.8 5.1-1.3 2-.7 4.1-1.5 6-2.4 1.9-.9 3.8-2 5.7-3.2 1.5-1 2.9-2 4.3-3.1 1.2-1 2.1-1.8 2.7-2.4l.7-.7.3-.2zM486.2 162.3s-.1 0-.2-.1l-.6-.2-2-.7-6.7-2.5c-2.6-1-5-1.7-6.8-2.2l-2.1-.6-.6-.2-.2-.1h.2l.6.1c.5.1 1.2.3 2.1.5 1.8.5 4.2 1.2 6.8 2.2s5 1.9 6.7 2.5l2 .8.5.2.3.3z"
													/>
													<path
													  className="prefix__st0"
													  d="M486.2 162.3s.1-.3.3-.8l.8-2.2c.7-1.9 1.7-4.7 2.7-8.3 1-4.2 1.8-8.4 2.3-12.7.5-2.5.4-5.1-.3-7.5-.4-1.3-1.1-2.4-2-3.4-.5-.5-.9-1-1.5-1.4-.5-.5-1.1-.9-1.7-1.1-1.3-.5-2.7-.7-4-.4-1.3.2-2.6.8-3.7 1.5-2.2 1.4-3.3 3.9-4.1 6.2-1.5 4.6-2.9 8.8-4.1 12.2l-2.8 8.2c-.3.9-.6 1.7-.8 2.2-.2.6-.3.8-.3.8l.2-.8.7-2.2c.7-2 1.6-4.8 2.7-8.3 1.1-3.5 2.5-7.6 4-12.3.4-1.2.9-2.3 1.5-3.4s1.6-2.1 2.7-2.9c1.1-.8 2.4-1.3 3.7-1.5 1.4-.3 2.8-.1 4.1.4.6.3 1.2.7 1.8 1.2.5.5 1 .9 1.5 1.5.9 1 1.6 2.2 2 3.5.7 2.5.8 5.1.3 7.6-.6 4.3-1.3 8.5-2.4 12.7-1 3.5-2 6.3-2.7 8.3-.5 1.9-.9 2.9-.9 2.9zM494.7 219.6l.8 58.1c0 4 .5 8 1.2 11.9 1.1 5.4 3 12.4 6.1 16.7 4.7 6.6 21.3 25.2 21.3 25.2l-14 16.3s-29.6-23.6-31.5-45.4c-1-11.1 0-77.3 0-77.3l16.1-5.5z"
													/>
													<path
													  className="prefix__st0"
													  d="M462 205.5l-.4 150.4h23.2l4.1-130.9s6.7-4.4 7.9-10.1c1.6-7.6.9-11.2.9-11.2l-35.7 1.8z"
													/>
													<path className="prefix__st7" d="M460.6 352.3h25.2v3.6h-25.2z" />
													<path
													  transform="rotate(-46.52 516.288 338.553)"
													  className="prefix__st7"
													  d="M503.7 336.7h25.2v3.6h-25.2z"
													/>
													<path
													  className="prefix__st0"
													  d="M522.7 329.5c0 .1-.1.1-.1.2l-.4.5-1.6 1.7c-1.3 1.5-3.2 3.5-5.3 5.7s-4 4-5.5 5.5l-1.7 1.6-.5.4c-.1.1-.1.1-.2.1 0-.1.1-.1.1-.2l.4-.5 1.6-1.7 5.4-5.6 5.3-5.6 1.7-1.7.5-.4c.1.1.2 0 .3 0z"
													/>
													<path
													  className="prefix__st7"
													  d="M479.6 204.7s0 .1-.1.4c-.2 1-.7 1.9-1.3 2.6-.6.6-1.1 1.2-1.8 1.8-.8.7-1.5 1.5-2.1 2.3-.7 1-.6 2.3-.7 3.6-.1 2.7-.2 5.8-.3 9.1s-.2 7.1-.4 11.1-.2 8.2-.3 12.7c-.2 9-.6 18.8-.8 29.2-.3 20.7-.7 39.4-.9 53-.2 13.2-.4 20.5-.4 22V351v-4.4c0-3.8.1-9.3.2-16.1.2-13.6.5-32.3.8-53 .2-10.4.6-20.2.8-29.2.1-4.5.3-8.8.4-12.7s.3-7.7.4-11.1.2-6.5.3-9.1c.1-1.3 0-2.7.7-3.7.6-.8 1.4-1.6 2.1-2.3l1.8-1.8c.4-.5.7-1 1-1.5.2-.3.3-.7.4-1.1l.2-.3zM465.8 206.5s-.2-.1-.3-.4-.2-.5-.1-.5.2.1.3.4.2.5.1.5zM467.1 208s-.2-.1-.4-.3-.3-.4-.3-.4.2.1.4.3.3.4.3.4zM468.9 209.1s-.2 0-.5-.1-.4-.3-.4-.3.2 0 .5.1.4.2.4.3zM470.7 209.6h-.5c-.3 0-.5-.1-.5-.2s.2-.1.5 0 .5.1.5.2zM472.7 209.5c0 .1-.2.1-.5.2s-.5 0-.5 0 .2-.1.5-.1.5-.1.5-.1zM474.6 208.8s-.2.2-.4.3-.5.2-.5.1.2-.2.4-.3.5-.1.5-.1zM476.2 207.6s-.1.2-.3.4-.4.3-.5.2.1-.2.3-.4.5-.2.5-.2zM477.4 206.1s0 .2-.2.5-.3.4-.4.4 0-.2.2-.5.4-.5.4-.4zM477.9 204.8s.1.1 0 .2-.1.2-.2.1-.1-.1 0-.2.2-.1.2-.1zM471.8 213.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM471.7 215.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM471.6 217.4s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM471.6 219.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM471.5 221.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM471.5 223.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM471.4 225.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM471.3 227.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM471.3 229.4s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM471.2 231.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM471.2 233.4s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM471.1 235.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM471.1 237.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM471 239.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM471 241.4c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.6-.1.5zM470.9 243.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.9 245.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.9 247.5s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.8 249.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.7 251.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.7 253.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.6 255.5s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.6 257.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.6 259.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.5 261.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.5 263.5s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.4 265.5s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.4 267.5s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.4 269.5s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.3 271.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.3 273.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.2 275.5c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.2 277.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.2 279.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.1 281.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470.1 283.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM470.1 285.6c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM470 287.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM470 289.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM469.9 291.6c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.9 293.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.9 295.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM469.9 297.6c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM469.8 299.6s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.8 301.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.7 303.6c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.7 305.6s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.5-.1.5zM469.6 307.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.6 309.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.6 311.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM469.5 313.6c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.5 315.6c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.4 317.6c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.4 319.7c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.4 321.7c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM469.3 323.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.3 325.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM469.2 327.7s-.1-.2-.1-.5.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.2 329.7c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.2 331.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM469.1 333.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM469.1 335.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM469 337.7c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM469 339.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM468.9 341.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM468.9 343.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM468.9 345.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5zM468.8 347.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM468.7 349.7c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5 0 .5-.1.5zM468.7 351.6c-.1 0-.1-.2-.1-.5s.1-.5.1-.5.1.2.1.5-.1.5-.1.5z"
													/>
													<path
													  className="prefix__st8"
													  d="M467 122.1c-.1-2-.7-10.9-.7-10.9s-6.3-.4-6.9-6.6-.9-20.4-.9-20.4c6.9-3.7 15.2-3.5 21.9.6l1.6 1 .2 7.2-.4 6.5-.3 17.7-14.5 4.9c.1 0 0 0 0 0z"
													/>
													<path
													  className="prefix__st0"
													  d="M459.5 94.1c0 .4.4.8.8.8s.8-.4.8-.8-.4-.8-.8-.8c-.5 0-.8.4-.8.8z"
													/>
													<path
													  className="prefix__st0"
													  d="M459.5 93.8c.1.1.7-.4 1.5-.5s1.5.3 1.6.2-.1-.2-.4-.4c-.4-.2-.8-.3-1.3-.3-.4 0-.9.2-1.2.5-.2.3-.3.5-.2.5zM469.2 93.1c-.3.3-.4.7-.2 1.1.3.3.8.4 1.1.2.3-.3.4-.8.1-1.1-.2-.4-.7-.5-1-.2z"
													/>
													<path
													  className="prefix__st0"
													  d="M468.9 93.4c.1.1.7-.4 1.5-.5s1.5.3 1.6.2-.1-.2-.4-.4c-.4-.2-.8-.3-1.3-.3-.4 0-.9.2-1.2.5-.2.3-.2.5-.2.5zM466.1 100.8c-.5.1-.9.2-1.4.2-.3.1-.6-.1-.8-.3-.1-.3-.1-.6 0-.9.2-.6.3-1.2.5-1.8.3-1.6.8-3.1 1.5-4.6-.2 1.6-.6 3.1-1 4.7-.2.6-.3 1.2-.5 1.8-.1.2-.1.4-.1.7 0 .1.2.2.4.2.5-.2 1-.1 1.4 0z"
													/>
													<path
													  className="prefix__st3"
													  d="M469 101.4c.8-.6-2.3 1.5-4.1 1.6.7.9 1.9 1.2 2.9.7 1.8-.8 1.2-2.3 1.2-2.3z"
													/>
													<path
													  className="prefix__st9"
													  d="M466.4 111.3c2.9-.3 5.7-1.3 8.1-3.1 0 0-1.7 4.6-7.9 4.6l-.2-1.5z"
													/>
													<path
													  className="prefix__st0"
													  d="M478.7 80.6c-1.7-1.5-3.6-2.7-5.7-3.6-2.1-.9-4.5-1-6.6-.1-.9.4-1.8 1.1-2.7 1.5-2 .8-4.5.2-6.3 1.5-1.6 1.3-2 3.6-1 5.4 1 1.7 2.8 2.9 4.9 3.1 2 .2 4-.1 5.9-.9 1-.5 2.3-.7 3.4-.4 1 .4 1.8 1.6 2.9 1.6s2.1-.6 2.8 0c.3.3.4.7.5 1.1.4 2.1 1.6 6.4 2 8.6 1.4.6 2.1-1.3 3.6-1.3.2-4.7 2.3-9.4 1.1-14-.2-1.2-.9-2.2-1.8-2.9-1-.7-2.3-.5-3.1.4"
													/>
													<path
													  className="prefix__st8"
													  d="M479.7 92.1c.1-.1 4.1-1.6 4.8 3.4s-4.5 4.1-4.6 3.9-.2-7.3-.2-7.3z"
													/>
													<path
													  className="prefix__st9"
													  d="M481.2 97.5s.1.1.2.1c.2.1.5 0 .7-.1.6-.5.9-1.3.7-2.1-.1-.4-.2-.8-.4-1.2-.1-.3-.4-.5-.8-.6-.2 0-.4.1-.5.3v.3c0 .1-.1-.1-.1-.3 0-.1.1-.2.2-.3.1-.1.3-.2.5-.2.4 0 .8.3 1 .6.3.4.4.9.5 1.3.2.9-.2 1.8-1 2.3-.3.1-.6.1-.8 0-.1 0-.2-.1-.2-.1z"
													/>
													<path
													  className="prefix__st0"
													  d="M477.7 77.3c.1 0 .4.8.7 1.8s.3 1.9.2 1.9-.5-.8-.7-1.8-.4-1.9-.2-1.9z"
													/>
													<path
													  className="prefix__st0"
													  d="M479.9 77.5c.1 0-.1.9-.5 1.8s-.8 1.7-1 1.6.1-.9.5-1.8.8-1.7 1-1.6z"
													/>
													<path
													  className="prefix__st8"
													  d="M467.8 156.1c-.3 1.4-.9 2.7-1.8 3.9-2.8 3.1-27.4-23.6-27.4-23.6-.2-1.7-.3-3.5-.2-5.2.2-1.1.6-2.3 1.1-3.3.6-.9-.3-2-1.2-1.7s-2.5 2.8-2.9 6.3c-.4 3.4-4-.8-5.1-2.5s-4.8-6.6-5.6-6.7c-1.1-.1-1.2 1.3-.1 2.9s4.3 6.4 3.9 6.7c-.8.6-6.6-7.8-6.6-7.8s-.9-1.7-2-1.2c-1.9 1 4.5 9.6 5.1 10.4.4.6-.2.8-.6.1-.4-.6-5.6-7.9-6.9-7-1.4.9 4.3 7 5 8.7.9 2-4.6-5.3-6-4.5-.5.3-.9.6 2.4 4.5 3.3 3.6 6.9 7 10.6 10.1 7 8.3 31.1 35.9 42.4 34.3 2.6-.3 4.8-1.7 6.2-3.9 3-4.7 5.6-9.6 7.7-14.8l-18-5.7z"
													/>
												  </g>
												  <g id="prefix__freepik--character-1--inject-499">
													<path
													  className="prefix__st1"
													  d="M202.4 357.5l-.2-9.2-17.2.3.2 13.4h1.1c4.8.2 24.1.6 27.3-.4 3.4-1.1-11.2-4.1-11.2-4.1z"
													/>
													<path
													  className="prefix__st0"
													  d="M191.3 361.8c-.3-1.4-1.1-2.7-2.3-3.6-1.1-.9-2.6-1.3-4-1.2l.1 4.8h6.2z"
													/>
													<path
													  className="prefix__st0"
													  d="M209.5 359.2s5.1 1.4 4.5 2.2-20.2 1.2-28.9.6v-.4l22.9-.2s.5-2.2 1.5-2.2z"
													/>
													<path
													  className="prefix__st7"
													  d="M184.9 361.6h4.3c2.6 0 6.3 0 10.3-.1s7.7-.2 10.3-.3l3.1-.1h1.2-.3l-.9.1-3.1.2c-2.6.1-6.3.3-10.3.3h-10.3l-3.1-.1h-1.2z"
													/>
													<path
													  className="prefix__st7"
													  d="M208 361.7c-.1-.6.1-1.1.4-1.6.3-.5.7-.9 1.2-1.1-.4.4-.7.8-1 1.2l-.6 1.5zM202.9 359.2s.1-.4.4-.8.5-.7.5-.7-.1.4-.4.8-.4.7-.5.7zM201.5 358.5s.2-.3.5-.6.6-.5.6-.4-.2.3-.5.6-.5.4-.6.4zM200.6 356.9c.3-.1.6-.1.9-.1.3 0 .6 0 .9.1-.3.1-.6.1-.9.1-.3 0-.6 0-.9-.1zM200.3 355.8c.3 0 .7 0 1 .1h1c-.3.2-.7.2-1 .2-.4 0-.7-.1-1-.3z"
													/>
													<path
													  className="prefix__st7"
													  d="M203.5 357.7s.4 0 1.1-.2c.4-.1.8-.2 1.1-.3l.6-.3c.2-.1.3-.3.1-.5-.4-.2-.9-.2-1.3-.1s-.7.3-.9.6c-.2.3-.4.6-.5 1v-.3c.1-.3.2-.5.4-.7.6-.8 1.6-1.1 2.5-.6.1.1.2.3.2.4 0 .1-.1.3-.3.4-.2.1-.4.2-.7.3l-1.2.3h-1.1z"
													/>
													<path
													  className="prefix__st7"
													  d="M203.8 357.8v-.7c-.1-.3-.2-.5-.3-.7-.2-.2-.5-.5-.7-.5s-.2.5 0 .7c.1.2.3.5.5.7.2.3.4.5.5.5-.3-.1-.5-.3-.7-.4-.2-.2-.4-.4-.5-.7-.1-.1-.2-.3-.2-.5s.1-.5.3-.5c.4 0 .7.2.9.5.2.2.3.5.3.8.1.3 0 .6-.1.8zM185.1 356.9s.1 0 .3-.1h1c1.1.1 2.1.4 2.9 1.1.8.6 1.5 1.5 1.8 2.5.1.3.2.6.2.9v.4s-.1-.5-.4-1.2c-.7-2-2.5-3.3-4.6-3.5-.3-.1-.7-.1-1.2-.1zM186.9 349.7c.1 1.2.1 2.4.1 3.5 0 1.2 0 2.4-.1 3.5-.1-1.2-.2-2.4-.1-3.5-.1-1.1-.1-2.3.1-3.5zM193.5 360.1c0-.1 1.1 0 2.5 0s2.5-.1 2.5 0c-.8.2-1.7.3-2.5.2-.8 0-1.7-.1-2.5-.2z"
													/>
													<path
													  className="prefix__st7"
													  d="M190.1 360.1s.3.1.4.4.1.6.1.6-.1-.2-.2-.5-.3-.5-.3-.5zM188.9 358.5l.4.2c.2.1.3.4.3.4l-.4-.2c-.2-.1-.4-.3-.3-.4zM187 357.9s.2-.2.5-.1.5.3.4.4-.2-.1-.5-.2-.4-.1-.4-.1zM185.7 357.5h.3c.2 0 .2.1.2.2s-.2.1-.3 0-.2-.1-.2-.2z"
													/>
													<path
													  className="prefix__st8"
													  d="M262.6 100.1s14.7-15.1 16-14.5-5.4 6.8-4.5 7.6 8 6.2-3.4 14.7l-8.1-7.8z"
													/>
													<path
													  className="prefix__st9"
													  d="M275.2 95.7c-.1.2-.1.3-.2.4-.2.4-.5.8-.7 1.2s-.7 1.1-1.1 1.7c-.2.4-.5.7-.9.9-.4.2-1 .2-1.3-.2-.3-.4-.2-.9.1-1.3.2-.4.4-.7.6-1 .4-.6.8-1.1 1.1-1.7l.8-1.1c.1-.1.2-.3.3-.4-.1.2-.1.3-.2.4l-.7 1.2c-.4.6-.7 1.1-1.1 1.7l-.6 1c-.2.3-.3.7-.1 1.1.3.2.7.3 1 .1.3-.2.6-.5.8-.8l1.1-1.7.8-1.1c0-.2.1-.3.3-.4z"
													/>
													<path
													  className="prefix__st9"
													  d="M275.9 97.3c0 .1 0 .3-.1.4-.1.4-.2.8-.4 1.1-.2.5-.6 1-1 1.5-.2.3-.5.5-.8.7-.4.2-.8.2-1.1-.1-.3-.3-.3-.8-.1-1.2.1-.3.3-.6.5-.9.4-.5.7-1 .9-1.5.2-.3.4-.7.6-1l.3-.3c-.1.1-.1.3-.2.4-.2.3-.4.7-.6 1s-.5.9-.9 1.5c-.2.3-.4.6-.5.9-.1.3-.1.7.1.9.3.2.6.2.9.1.3-.2.6-.4.8-.6.4-.4.7-.9 1-1.4.3-.5.5-1 .6-1.5z"
													/>
													<path
													  className="prefix__st8"
													  d="M267.1 97l5.4-.4h.3c.3.1.3.5.3.8-.3.9-1 1.7-1.9 2-.9.3-1.8.5-2.8.5l-2.6.1"
													/>
													<path
													  className="prefix__st9"
													  d="M265.9 100c.2 0 .4-.1.6-.1l1.6-.1c.8 0 1.6-.1 2.3-.3.9-.2 1.8-.7 2.3-1.4.2-.4.5-.9.2-1.3-.1-.2-.3-.1-.6-.1l-.7.1-2.3.1-1.6.1h-.6c.2 0 .4-.1.6-.1l1.6-.1 2.3-.2h1.1c.2 0 .3.1.4.2.1.2.2.5.1.8-.1.3-.2.5-.3.7-.6.8-1.5 1.3-2.5 1.5-.8.1-1.6.2-2.4.2l-1.6.1c-.2 0-.4-.1-.5-.1zM276.9 98.8s0 .1-.1.3l-.3.9c-.1.5-.3.9-.5 1.3-.2.2-.4.5-.6.6-.1.1-.3.1-.5.1s-.3-.1-.4-.3c-.2-.3-.2-.6-.1-.9.1-.3.2-.5.3-.8l.6-1.3c.2-.4.4-.8.6-1.1-.1.4-.3.8-.4 1.2l-.5 1.3c-.2.5-.6 1-.3 1.5.1.2.4.3.6.1h.1c.2-.1.4-.3.5-.5.2-.4.4-.8.5-1.3 0-.4.2-.8.5-1.1z"
													/>
													<path
													  className="prefix__st9"
													  d="M270 104.3c-.1 0 .2-1 .3-2.3s-.1-2.3 0-2.3c.2.8.3 1.5.2 2.3 0 .8-.2 1.6-.5 2.3z"
													/>
													<path
													  className="prefix__st0"
													  d="M200.3 95c0 4 2.1 7.6 5.4 9.7.9.5 1.8 1 2.7 1.6.9.6 1.4 1.6 1.5 2.6-.1 1.6-1.7 2.7-3.2 3.4 1.6 1.5 1.7 4.1.2 5.7-1.5 1.6-4.1 1.7-5.7.2l-.3-.3c-.3 3.1-2.4 5.8-5.5 6.6-3 .7-6.2.1-8.7-1.8-2.4-1.9-4.4-4.4-5.5-7.2"
													/>
													<path
													  className="prefix__st8"
													  d="M192.9 123.6c-.3-1.5.4-8 .4-8s5.9-.6 6.3-6.5 0-19.5 0-19.5l-10.8-5.3-11.9 9 1.8 29.4 14.2.9z"
													/>
													<path
													  className="prefix__st0"
													  d="M198.3 99.5c0 .4-.3.8-.8.8s-.8-.3-.8-.8.3-.8.8-.8.8.4.8.8zM199.1 98.7c-.1.1-.6-.4-1.5-.4s-1.4.4-1.5.2.1-.2.3-.4c.4-.2.8-.3 1.2-.3.4 0 .8.2 1.2.5.2.2.3.3.3.4zM189.6 99.5c0 .4-.3.8-.7.8-.4 0-.8-.3-.8-.7 0-.4.3-.8.7-.8.5 0 .8.3.8.7zM190.1 98.7c-.1.1-.7-.4-1.5-.4s-1.4.4-1.5.2.1-.2.3-.4c.4-.2.8-.3 1.2-.3.4 0 .8.2 1.2.5.3.2.3.3.3.4zM193 105.5c.4-.1.9-.2 1.3-.2.2 0 .4 0 .5-.2 0-.2 0-.5-.1-.6l-.5-1.7c-.4-1.2-.7-2.3-1-3.1-.1-.4-.2-.9-.3-1.3.2.4.4.8.5 1.2.3.8.6 1.8 1 3 .2.6.4 1.1.5 1.7.1.3.1.6.1.8-.1.2-.4.4-.7.3-.4.1-.9.1-1.3.1z"
													/>
													<path
													  className="prefix__st3"
													  d="M190.3 106.3c-.8-.6 2.3 1.4 3.9 1.4-.6.8-1.7 1.2-2.7.8-1.6-.8-1.2-2.2-1.2-2.2z"
													/>
													<path
													  className="prefix__st9"
													  d="M193.2 115.6c-2.8-.1-5.5-1-7.8-2.6 0 0 1.8 4.3 7.7 4.1l.1-1.5z"
													/>
													<path
													  className="prefix__st0"
													  d="M197.1 85.3c-5.8-6.1-9.8-4.8-12.1-4.8-5.1.6-9.7 3.2-12.7 7.4-1.6 1.7-4 7.2-4.2 9.1-.1 2-.1 3.9 0 5.9 0 2-.5 4.1-1.9 5.4-.9.8-2.2 1.3-2.8 2.4-.5 1.4 0 3 1.3 3.8 1.3.7 2.7 1 4.2.9-.2 3 1.8 5.7 4.8 6.3 1.5.2 3-.2 4.2-1.1 1 1 2 1.9 3.1 2.7.2-8.6.1-17.1-.5-25.7 3.9-.7 11-2.8 12.2-9.1 1.6 3.6 4 5.5 7.1 8.2-.1 0 3.1-5.4-2.7-11.4z"
													/>
													<path
													  className="prefix__st0"
													  d="M180.9 95.3c.8-.1 1.6-.1 2.4 0 1.9.2 3.8 0 5.6-.7.9-.4 1.8-1 2.3-1.9.5-.7.8-1.5.9-2.3.3-1.4.1-2.4.2-2.4.3.8.3 1.6.1 2.4-.1.9-.4 1.8-.9 2.5-.6.9-1.5 1.7-2.5 2.1-1.9.7-3.9.9-5.8.5-.8.1-1.6 0-2.3-.2zM165.5 109.7c.3 0 .7-.1 1-.1.8-.3 1.4-1 1.6-1.9.2-1.3-.1-2.6-.7-3.8-.3-.7-.6-1.5-.8-2.3-.2-.9-.3-1.8-.2-2.6.2-1.7.8-3.3 1.8-4.7.8-1.1 1.7-2.2 2.6-3.1.8-.8 1.6-1.4 2.1-1.8.2-.2.5-.4.8-.6.1.1-1 1-2.6 2.7-.9 1-1.8 2-2.5 3.1-.9 1.4-1.4 2.9-1.6 4.5-.1.8 0 1.7.1 2.5.2.8.5 1.5.8 2.2.6 1.3.9 2.7.6 4.1-.2 1-1 1.7-1.9 2-.3.1-.5.1-.8 0-.1-.2-.2-.2-.3-.2zM208.2 101.3s.2.2.2.7c0 .7-.4 1.3-1 1.7-.9.5-2 .5-3 0-1.1-.6-1.9-1.5-2.5-2.6-1.1-1.9-1.8-3.9-2.1-6.1-.1-.9-.1-1.8 0-2.7.1 0 .1 1 .4 2.6.4 2.1 1.1 4.1 2.1 5.9.5 1 1.3 1.8 2.3 2.4.8.5 1.7.5 2.5.1.5-.3.9-.8 1-1.4.2-.4.1-.6.1-.6zM199.1 193.8s20 65.1 18.8 86.1-15.9 73.2-15.9 73.2l-2.9-159.3z"
													/>
													<path
													  className="prefix__st0"
													  d="M170.9 182.7c-.4-.1-9.2 12.8-9.5 23.9 0 1.1 0 2.2.1 3.3.4 3.9 1.3 7.7 2.8 11.3 7.4 18.8 15.1 41 15.2 46.1.4 15.6 3.4 87.5 3.4 87.5l21.6-1.5-.7-85.9-5.3-85.3-27.6.6z"
													/>
													<path
													  className="prefix__st7"
													  d="M182.6 182.3c.1 0 .2 2.4.2 6.8s-.2 10.7.1 18.5c.1 2 .1 4 .3 6.1s.3 4.3.6 6.6c.5 4.6 1.1 9.4 1.9 14.5s1.7 10.4 2.5 16 1.4 11.3 1.7 17.3.3 11.8.4 17.4.2 11 .4 16.2c.3 10.3.7 19.6 1 27.4l.7 18.5c.1 2.2.1 3.9.2 5s0 1.8 0 1.8c0-1.4-.4-9.9-1-25.2-.3-7.8-.7-17.1-1-27.4-.1-5.1-.3-10.6-.4-16.2s0-11.4-.4-17.4-.9-11.7-1.7-17.2-1.7-10.9-2.5-16-1.5-10-1.9-14.5c-.2-2.3-.4-4.5-.6-6.6s-.2-4.2-.3-6.1c-.3-7.8 0-14.1 0-18.5v-5c0-.8-.1-1.4-.2-2z"
													/>
													<path
													  className="prefix__st7"
													  d="M182.7 351.7h21.7v3.3h-21.7zM184.1 183c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM184.1 185s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM184.2 187s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM184.3 189c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM184.3 191c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM184.4 193c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM184.4 195c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM184.5 197c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM184.6 199s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.5-.1.5zM184.6 201c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM184.7 203c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM184.7 205c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM184.7 207c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM184.8 209s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM184.9 211c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM184.9 213s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM185 215c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM185.1 217c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM185.3 219c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM185.5 221c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM185.7 223c-.1 0-.1-.2-.1-.5v-.5s.1.2.1.5v.5zM185.9 225c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5 0 .5 0 .5zM186.1 227c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5.1.5 0 .5zM186.4 228.9c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5 0 .5 0 .5zM186.7 230.9c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5 0 .5 0 .5zM187 232.9s-.1-.2-.2-.5 0-.5 0-.5.1.2.2.5 0 .5 0 .5zM187.3 234.9s-.1-.2-.2-.5 0-.5 0-.5.1.2.2.5 0 .5 0 .5zM187.6 236.8s-.1-.2-.2-.5 0-.5 0-.5.1.2.2.5 0 .5 0 .5zM187.9 238.8s-.1-.2-.2-.5 0-.5 0-.5.1.2.2.5.1.5 0 .5zM188.2 240.8c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5.1.5 0 .5zM188.6 242.7c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5 0 .5 0 .5zM188.9 244.7s-.1-.2-.2-.5 0-.5 0-.5.1.2.2.5.1.5 0 .5zM189.2 246.7c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5.1.4 0 .5zM189.6 248.6c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5 0 .5 0 .5zM189.9 250.6s-.1-.2-.2-.5 0-.5 0-.5.1.2.2.5 0 .5 0 .5zM190.1 252.6c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5.1.5 0 .5zM190.4 254.6s-.1-.2-.2-.5 0-.5 0-.5.1.2.2.5.1.5 0 .5zM190.6 256.5c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.2.5.1.5 0 .5zM190.9 258.5c-.1 0-.1-.2-.2-.5s0-.5 0-.5.1.2.1.5.1.5.1.5zM191.1 260.5c-.1 0-.1-.2-.1-.5v-.5s.1.2.1.5v.5zM191.3 262.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM191.4 264.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM191.6 266.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM191.7 268.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.5-.1.5zM191.8 270.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM191.9 272.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.5-.1.5zM191.9 274.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.5-.1.5zM191.9 276.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM191.9 278.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM191.9 280.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM192 282.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192 284.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192 286.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM192.1 288.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192.1 290.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192.1 292.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM192.2 294.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192.2 296.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM192.3 298.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192.3 300.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM192.4 302.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM192.5 304.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192.5 306.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM192.6 308.5c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192.7 310.5s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5-.1.4-.1.5zM192.7 312.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM192.9 314.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM192.9 316.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM193 318.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM193 320.4s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM193.1 322.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM193.2 324.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM193.3 326.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM193.4 328.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM193.4 330.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM193.5 332.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM193.6 334.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM193.7 336.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM193.7 338.4s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5.1.5-.1.5zM193.9 340.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM193.9 342.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM194 344.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM194.1 346.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5zM194.1 348.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5 0 .5-.1.5zM194.2 350.4c-.1 0-.1-.2-.1-.5s0-.5.1-.5.1.2.1.5-.1.5-.1.5z"
													/>
													<path
													  className="prefix__st7"
													  d="M194.2 352.4s-.1-.2-.1-.5 0-.5.1-.5.1.2.1.5 0 .5-.1.5zM194.3 353.9c-.1 0-.1-.1-.1-.2s0-.2.1-.2.1.1.1.2 0 .2-.1.2zM200 204.9c-.3.2-.6.2-.9 0-.4-.1-.7-.4-.9-.7-.3-.4-.4-.9-.5-1.4-.2-2.1-.3-5.1-.5-8.4s-.3-6.1-.4-8.4l-.1-2.5v-.7-.2.2c0 .2 0 .4.1.7 0 .7.1 1.6.2 2.5.1 2.3.3 5.2.5 8.4s.3 6.1.4 8.4c0 .5.2.9.4 1.3.2.3.5.5.8.7.3.2.6.2.9.1zM164 220.2c.3 0 .5-.1.8-.2.7-.4 1.2-.9 1.5-1.6.4-1.1.5-2.2.4-3.3-.1-1.4-.2-2.8-.4-4.1-.4-2.4-1-4.8-1.9-7.1h.1l-2.4.4-.6.1h-.2c.1 0 .1-.1.2-.1l.6-.1 2.4-.5h.1v.1c.9 2.3 1.6 4.7 2 7.1.2 1.4.4 2.8.4 4.1.1 1.1 0 2.3-.4 3.4-.3.7-.9 1.3-1.6 1.6-.4.2-.7.2-1 .2z"
													/>
													<path
													  className="prefix__st7"
													  d="M165.2 206.9c-.6.3-1.2.4-1.9.5-.7.2-1.3.3-2 .3.6-.2 1.3-.4 1.9-.5.6-.2 1.3-.3 2-.3zM273.5 108.3l-11.2-9.2c-30.4 27.5-69.7 24.3-69.7 24.3v.1c-1.8-.3-11-1.8-14.1-1.8-2.4 0-7.9-.5-11.8 3.2l-.3.3c-3.5 3.5-39 38.4-35.2 47 4 9.1 37.6 28.9 37.6 28.9l8.2-14.8s-2.5-1.7-6-4l27.5-.7 1.2-20.6s4.7-5.2 4.7-9c0-2.6-1.5-7-3.3-11.4 43.3-3.6 72.4-32.3 72.4-32.3zm-121.9 59c.3-1.1 7.4-8.8 13.7-15.6 2.2 13.5 5.2 29 5.5 30.5-7.7-5.2-19.6-13.5-19.2-14.9z"
													/>
													<path
													  className="prefix__st3"
													  d="M202.8 156.5h-1c-1 0-1.9-.1-2.9-.4-1.5-.4-2.8-1.4-3.5-2.8-.4-.9-.4-2 0-2.9.5-1 1.5-1.7 2.6-1.7 1.3.2 2.3 1.1 2.5 2.4.2 1.3-.1 2.7-1 3.7-1.9 2.3-4.7 3.4-7.6 3.1-1.6-.1-3.1-.6-4.4-1.5-1.4-.9-2.4-2.2-2.9-3.8-.2-.8-.2-1.7.1-2.5.4-.8 1-1.4 1.9-1.8.8-.4 1.8-.2 2.5.3.7.6 1 1.5.9 2.4-.1.9-.4 1.7-.9 2.5-.5.7-1.1 1.3-1.8 1.9-1.3 1-2.9 1.7-4.6 1.9-3.2.5-6.4-.7-8.5-3.1-.5-.6-.8-1.3-.9-2.1-.1-.7 0-1.5.3-2.2.3-.7.9-1.2 1.6-1.4.7-.2 1.4-.1 2.1.2 1.2.6 2.1 1.8 2.1 3.1 0 1.2-.5 2.4-1.4 3.3-1.5 1.5-3.5 2.3-5.6 2.1-1.6-.1-3.1-.6-4.4-1.4-.8-.5-1.5-1.2-2.1-2-.2-.3-.4-.6-.5-.9 0 0 .2.3.6.8.6.8 1.3 1.4 2.1 1.9 1.3.8 2.8 1.3 4.3 1.3 2 .1 4-.6 5.4-2.1.8-.8 1.3-1.9 1.3-3.1-.1-1.3-.8-2.4-2-2.9-.6-.3-1.3-.3-1.9-.2-.6.2-1.1.7-1.4 1.3-.3.6-.4 1.3-.2 2 .1.7.5 1.4.9 1.9 2 2.4 5.2 3.5 8.3 3 1.6-.2 3.2-.8 4.5-1.8.7-.5 1.2-1.1 1.7-1.8s.7-1.5.8-2.3c.1-.8-.2-1.6-.8-2.2-.6-.5-1.5-.6-2.2-.3-.7.3-1.3.9-1.7 1.6-.3.7-.3 1.5-.1 2.3.4 1.5 1.4 2.8 2.8 3.6 1.3.8 2.7 1.3 4.2 1.4 2.8.3 5.6-.8 7.4-3 .8-1 1.2-2.2 1-3.5-.2-1.1-1.2-2-2.3-2.2-1.1 0-2 .6-2.5 1.6-.4.8-.4 1.8 0 2.7.7 1.4 1.9 2.4 3.4 2.8.9.3 1.9.4 2.9.4l.9.4zM198.9 175.5l-.5.3c-.3.2-.8.5-1.5.9-.8.5-1.6.9-2.5 1.2-1.2.4-2.4.5-3.6.3-1.5-.1-2.9-.6-4.1-1.6-.6-.6-1-1.4-1.1-2.2-.1-.9.3-1.8 1-2.4.4-.3.8-.5 1.3-.5s1 .2 1.4.5c.8.7 1.1 1.7.9 2.7-.3 1-.8 1.9-1.6 2.5-.8.6-1.7 1.2-2.6 1.5-1.9.7-4 .8-5.9.4-1.9-.4-3.5-1.4-4.6-3-.5-.8-.6-1.7-.2-2.6.4-.8 1.1-1.3 2-1.5.4-.1.8.1 1.2.3.3.3.5.6.6 1 .2.7 0 1.5-.4 2.1-.8 1-1.8 1.7-3 2.1-.9.3-1.8.4-2.7.4-.6 0-1.2-.1-1.7-.3-.2-.1-.4-.1-.6-.2.7.2 1.5.3 2.3.3.9 0 1.8-.1 2.6-.5 1.1-.4 2.1-1.1 2.8-2 .4-.5.5-1.2.4-1.9-.1-.7-.8-1.2-1.5-1.1-.8.1-1.4.6-1.8 1.3-.3.8-.2 1.6.2 2.3 1.1 1.5 2.7 2.5 4.4 2.9 1.9.5 3.9.3 5.8-.4.9-.4 1.8-.9 2.5-1.5s1.3-1.4 1.5-2.3c.2-.9-.1-1.8-.8-2.4-.7-.6-1.6-.6-2.3 0-.7.5-1 1.3-.9 2.1.1.8.4 1.5 1 2 1.1.9 2.5 1.5 3.9 1.6 1.2.2 2.4.1 3.5-.3.9-.3 1.7-.7 2.5-1.1l1.5-.9c.3.1.6 0 .6 0zM213.9 122.2c.4.2.8.5 1.1.8.9.9 1.5 2 1.6 3.3.1.9 0 1.7-.3 2.5-.4.9-1 1.8-1.7 2.4-.9.7-1.9 1.1-3 1.3-.6.1-1.2.1-1.7 0-.6-.1-1.2-.4-1.6-.9-.2-.3-.3-.7-.2-1 .1-.3.3-.6.6-.8.5-.3 1.1-.5 1.7-.5 1.1 0 2.2.5 3 1.3.7.7 1.1 1.7 1.1 2.7.1.9-.1 1.7-.4 2.5-.5 1.1-1.4 2.1-2.5 2.7-.3.2-.6.3-.9.5-.1 0-.2.1-.3.1 0 0 .5-.2 1.2-.7 1-.7 1.8-1.6 2.4-2.7.3-.8.5-1.6.4-2.4-.1-.9-.4-1.8-1.1-2.5-.7-.8-1.7-1.2-2.8-1.2-.5 0-1.1.1-1.5.4-.4.3-.6.9-.3 1.3s.8.7 1.4.8c.5.1 1.1.1 1.6 0 1-.2 2-.6 2.8-1.2 2.3-1.8 2.7-5.1.9-7.4-.1-.2-.3-.3-.4-.5-.4-.3-.8-.5-1.1-.8zM228.5 118.6c.2.2.4.4.5.6.1.3.2.6.2.9-.1.4-.2.8-.4 1.1-.5.9-1.1 1.8-1.8 2.6-.9.9-1.7 1.8-2.5 2.9-1.2 1.9-1.8 4.2-1.6 6.5.1.9.3 1.9.5 2.8-.1-.2-.2-.5-.3-.7-.2-.7-.4-1.4-.4-2.1-.2-2.3.3-4.7 1.6-6.7.7-1.1 1.6-2 2.5-2.9.7-.7 1.3-1.6 1.8-2.4.2-.3.4-.7.4-1.1 0-.3 0-.6-.1-.8-.2-.4-.4-.6-.4-.7zM239.5 130.5c-.5.2-1 .3-1.5.3-1.4 0-2.8-.7-3.6-1.9-1-1.8-1.1-4.1-.2-6 .5-1.2 1.2-2.2 2.2-2.9 1.1-.9 2.5-1.1 3.8-.8 1.4.4 2.3 1.7 2.2 3.1 0 .7-.3 1.3-.8 1.7-.5.4-1.1.6-1.7.6-1.1 0-2.3-.4-3.1-1.2-.7-.7-1.2-1.5-1.5-2.5-.4-1.4-.3-2.8.2-4.1.2-.5.5-.9.9-1.3-.3.4-.5.9-.7 1.3-.5 1.3-.6 2.7-.2 4 .3.9.8 1.7 1.5 2.4.8.7 1.8 1.1 2.9 1.1.6 0 1.1-.2 1.5-.6.4-.4.7-.9.7-1.5.1-1.3-.8-2.4-2-2.8-1.2-.3-2.5-.1-3.5.7-.9.7-1.7 1.7-2.1 2.8-.9 1.8-.9 4 .1 5.8.8 1.2 2 1.9 3.4 1.9.6.1 1 0 1.5-.1zM247.4 110.2c.2.1.4.1.6.2.5.3 1 .6 1.5 1 .7.6 1.3 1.3 1.7 2.1.5 1 .9 2 1.1 3.1.4 2 .2 4-.7 5.9-.2.5-.6 1.1-.9 1.6-.1.2-.3.4-.4.5.4-.7.8-1.4 1.1-2.1.7-1.8.9-3.8.6-5.7-.2-1-.6-2.1-1.1-3-.4-.7-1-1.4-1.6-2-.5-.6-1.2-1.1-1.9-1.6zM263.9 116.3c-.4.2-.8.3-1.3.3s-1 0-1.5-.1c-.7-.2-1.3-.6-1.7-1.1-1.2-1.4-1.8-3.2-1.5-5 .1-1.1.7-2.1 1.6-2.7.5-.3 1-.5 1.6-.5.6 0 1.2.2 1.7.6.5.4.8.9.9 1.5.1.6-.1 1.2-.5 1.6-.7.8-1.8 1.2-2.9 1.1-1.8-.2-3.4-1.2-4.4-2.8-.4-.6-.6-1.3-.6-2 0-.5.2-1 .4-1.5.2-.4.3-.7.4-.9 0-.1.1-.2.2-.3 0 .1-.1.2-.1.3-.1.3-.2.6-.4.9-.2.5-.3.9-.4 1.4 0 .7.2 1.3.6 1.8 1 1.5 2.5 2.4 4.2 2.6 1 .1 2-.2 2.7-1 .3-.4.5-.9.4-1.4-.1-.5-.4-1-.8-1.3-.9-.7-2.1-.7-2.9 0-.8.6-1.4 1.5-1.5 2.5-.3 1.7.3 3.5 1.4 4.8.8.9 1.9 1.4 3.1 1.3.4 0 .8-.1 1.3-.1zM199 165.8c-.3.3-.6.6-.9.8-.9.7-2 1.1-3.1 1.4-1.7.4-3.4.5-5 .3-2-.3-4.1-.7-6.1-1.2s-4-.9-6-1c-1.7-.1-3.4.1-5 .7-1.1.4-2 .9-2.9 1.7-.6.5-.8.9-.9.9.2-.4.5-.7.8-1 .8-.8 1.8-1.4 2.9-1.8 1.6-.6 3.3-.8 5-.8 2.1.1 4.1.5 6.1 1s4 1 6 1.2c1.7.2 3.4.1 5-.2 1.5-.4 2.9-1 4.1-2zM156.6 135.2c.5-.4 1.2-.5 1.9-.4.8.2 1.5.5 2.1 1 .7.5 1.4 1.2 2.3 1.9s1.7 1.6 2.7 2.4c1.1.8 2.3 1.4 3.7 1.6 3.1.4 6.3 0 9.2-1.3 3.1-1.2 6-2.8 8.8-3.5 1.3-.4 2.7-.6 4.1-.6 1.2 0 2.4.3 3.6.6 1.7.5 3.2 1.6 4.2 3.1.2.2.3.5.4.7.1.2.2.4.2.6.1.2.1.3.1.5-.2-.6-.5-1.2-.9-1.7-1-1.4-2.5-2.4-4.1-2.9-1.1-.4-2.3-.6-3.5-.6-1.4 0-2.7.2-4 .6-2.8.8-5.7 2.3-8.8 3.5-2.9 1.3-6.2 1.8-9.4 1.3-1.4-.3-2.7-.9-3.8-1.7-1-.8-1.9-1.7-2.7-2.4-.8-.7-1.6-1.4-2.3-1.9-.6-.5-1.3-.8-2-1-.6-.1-1.2-.1-1.8.2zM202.1 123.5c.1.3.1.5.1.8.1.8 0 1.6-.1 2.4-.3 1.2-.9 2.4-1.7 3.3-1.1 1.3-2.6 2.2-4.2 2.5-2 .3-4.1-.1-5.8-1.3-1-.6-1.7-1.5-2.2-2.5-.3-.6-.2-1.3.2-1.8s1-.8 1.6-.8c.7-.1 1.3.1 1.8.6s.7 1.1.8 1.8c.1 1.4-.5 2.7-1.6 3.5-1.1.8-2.3 1.4-3.7 1.7-1.3.4-2.7.6-4.1.5-1.4-.1-2.8-.6-3.9-1.4-1.1-.9-1.8-2.2-1.8-3.6-.1-1.4.6-2.7 1.8-3.4 1.2-.6 2.6-.5 3.6.4.9.9 1.1 2.3.6 3.4-.5 1.1-1.3 1.9-2.4 2.3-1.9.8-3.9 1.1-5.9.8-2.9-.4-5.6-1.8-7.5-4-.5-.6-1-1.2-1.4-1.9-.3-.5-.4-.7-.4-.7.5.9 1.1 1.8 1.9 2.5 2 2.1 4.6 3.4 7.5 3.8 2 .3 3.9 0 5.8-.8 1-.4 1.8-1.2 2.2-2.2.5-1 .3-2.3-.5-3.1-.9-.8-2.2-.9-3.3-.3-1.1.6-1.7 1.8-1.6 3.1 0 1.3.7 2.5 1.7 3.3 1.1.8 2.4 1.3 3.7 1.4 1.4.1 2.7-.1 4-.5 1.3-.3 2.5-.9 3.6-1.6 1-.7 1.6-2 1.5-3.2 0-.6-.3-1.2-.7-1.6-.4-.4-1-.6-1.6-.5-.6 0-1.1.3-1.5.7-.3.4-.4 1-.1 1.5.5 1 1.2 1.8 2.1 2.4 1.6 1.1 3.6 1.6 5.6 1.3 1.6-.3 3.1-1.1 4.1-2.3.8-.9 1.4-2 1.7-3.2.2-1.2.2-2.3.1-3.3zM151 141c.1-.1.3-.1.4-.2.3-.1.7-.2 1.2-.4 1.5-.4 3-.4 4.5.2 1 .4 1.9 1 2.6 1.8.8.9 1.3 2.1 1.4 3.3.1 2.7-2.1 5-4.8 5h-.8c-.7-.1-1.4-.4-2-.9-.6-.5-.8-1.3-.6-2 .2-.7.6-1.3 1.2-1.7.5-.4 1.1-.7 1.8-.8 2.2-.6 4.6 0 6.3 1.6 1.1 1.1 1.9 2.5 2.1 4 .1.5.1 1.1 0 1.7 0-.5-.1-1.1-.1-1.6-.3-1.5-1-2.8-2.1-3.8-1.7-1.5-4-2-6.1-1.5-.6.1-1.2.4-1.7.8s-.9.9-1.1 1.5c-.1.6.1 1.3.6 1.8s1.2.7 1.9.8c2.5.3 4.8-1.5 5.2-4v-.7c0-1.2-.5-2.3-1.3-3.2-.7-.8-1.5-1.4-2.5-1.8-1.4-.6-2.9-.7-4.4-.3-.5.1-.9.2-1.2.3-.2.1-.3.1-.5.1zM155.3 162.7c.1-.3.1-.6.1-.9-.2-.8-.5-1.5-1-2.2-.7-1-1.9-1.4-3.1-1.2-1.3 0-2.8.6-4.4.5-2.9-.1-5.2-2.6-5.1-5.5 0-.8.2-1.7.6-2.4.2-.3.4-.5.6-.6 0 0-.2.2-.5.7-.4.7-.6 1.5-.5 2.3 0 1.2.4 2.4 1.1 3.3.9 1.1 2.3 1.8 3.8 1.9 1.5.1 3-.5 4.4-.5.7-.1 1.4 0 2 .3.6.2 1 .6 1.3 1.1.5.7.8 1.5.9 2.3.1.3 0 .6-.2.9zM144.3 185c.5 0 .9-.2 1.4-.4.5-.3.9-.7 1.1-1.2.3-.7.3-1.4.2-2.1-.1-.9-.3-1.8-.6-2.6-.3-1-.7-1.9-1.3-2.7-.7-.9-1.8-1.3-2.9-1.1-.6.1-1 .5-1.2 1.1-.2.6-.2 1.2 0 1.7.5 1.1 1.6 1.8 2.8 1.8 1.1 0 2.2-.4 3.1-1.1 1.5-1.3 2.6-2.8 3.5-4.5.6-1.2 1-2.4 1.1-3.7.1-.9 0-1.4.1-1.4.1.5.1 1 .1 1.5-.1 1.3-.5 2.6-1.1 3.8-.8 1.8-2 3.4-3.5 4.7-.9.8-2.1 1.2-3.2 1.2-.6 0-1.3-.2-1.8-.5-.6-.3-1-.9-1.2-1.5-.2-.6-.2-1.3 0-2 .2-.6.8-1.1 1.4-1.3 1.2-.2 2.5.2 3.2 1.2.6.8 1.1 1.8 1.4 2.8.3.9.5 1.8.6 2.7.1.8 0 1.5-.3 2.2-.3.5-.7.9-1.2 1.2-.3.2-.7.2-1.1.3-.4-.1-.5-.1-.6-.1zM157.4 192.7c.3 0 .5-.1.8-.2.7-.3 1.2-.9 1.4-1.5.3-1 .3-2.1-.1-3.1-.4-1.1-1.1-2.3-1.6-3.7-.2-.7-.3-1.4-.3-2.1.1-.7.3-1.3.7-1.9.7-.9 1.7-1.6 2.8-1.8.7-.2 1.5-.2 2.2-.1.3 0 .5.1.8.2-1-.1-2 0-3 .2-1 .3-2 .9-2.6 1.8-.4.5-.6 1.1-.7 1.7 0 .7 0 1.4.3 2 .4 1.3 1.2 2.5 1.6 3.7.5 1.1.5 2.2.1 3.3-.3.7-.9 1.3-1.6 1.6-.2-.1-.5 0-.8-.1z"
													/>
													<path
													  className="prefix__st0"
													  d="M163.6 153.6c.3-.4.6-.9 1-1.3.6-.8 1.6-1.9 2.8-3.3 1.2-1.4 2.6-3 4.1-4.8.8-.9 1.5-1.9 2.3-2.9.8-1 1.6-2.1 2.2-3.3 1.2-2.3 1.9-4.8 2-7.3.1-2.1-.7-4.1-2.1-5.7-1-1-2.2-1.7-3.6-2-.5-.1-1-.1-1.5-.1 0 0 .1 0 .4-.1.4-.1.8-.1 1.2 0 1.5.2 2.8.9 3.8 1.9 1.5 1.6 2.3 3.7 2.3 5.9-.1 2.6-.7 5.2-2 7.6-.6 1.2-1.4 2.3-2.2 3.4-.8 1-1.6 2-2.4 2.9-1.6 1.8-3 3.4-4.2 4.7l-2.9 3.1c-.4.6-.8.9-1.2 1.3zM152.4 167.3c-1.1.6-2.3 1-3.5 1.3-1.2.4-2.4.7-3.6.8 1.1-.6 2.3-1 3.5-1.3 1.2-.4 2.4-.7 3.6-.8z"
													/>
													<path
													  className="prefix__st0"
													  d="M152 167.2c.1.1-1.1.9-2.2 2.1s-1.8 2.5-1.9 2.4c.5-2.1 2-3.7 4.1-4.5zM202.4 143.5c-.5-.6-.9-1.3-1.2-2.1-.8-1.7-1.6-3.5-2.2-5.3-.6-1.8-1.2-3.6-1.6-5.5-.2-.8-.4-1.5-.4-2.3.3.7.6 1.5.7 2.2.4 1.4 1 3.3 1.7 5.4s1.5 4 2 5.3c.5.8.7 1.5 1 2.3zM191.8 153.1c-.3.7-.7 1.4-1.3 2-2.6 3-6.5 4.7-10.5 4.5-.8 0-1.6-.1-2.4-.4 0-.1.9.1 2.4.1 3.9-.1 7.5-1.6 10.2-4.4 1-1.1 1.5-1.9 1.6-1.8z"
													/>
													<path
													  className="prefix__st8"
													  d="M184.9 202.5s-6.9 1.5-7.8.7 1.3-1.6 1.3-1.6-2 .2-2-.5.7-1.2.7-1.2l7.8 2.6z"
													/>
													<path
													  className="prefix__st8"
													  d="M175.5 189.1s9.7 4.4 9.8 4.7.4 7.3-.5 8.7-13.7-5.5-13.7-5.5l4.4-7.9z"
													/>
													<path
													  className="prefix__st9"
													  d="M182.7 200.9h-.5l-1.3-.2c-1.5-.2-2.9-.5-4.3-.9s-2.8-1-4-1.9l-1.1-.8c-.3-.2-.4-.3-.4-.3.1.1.3.1.4.2l1.1.7c1.2.8 2.5 1.4 3.9 1.8 1.4.4 2.8.7 4.3 1l1.3.2c.2.1.4.1.6.2zM182.6 201c-.7.3-1.5.5-2.2.6-.8.1-1.5.2-2.3.1 0-.1 1-.1 2.3-.3s2.2-.4 2.2-.4z"
													/>
												  </g>
												</svg>
											</div>
										</div>
									</div>
			    				</div>
								<div className="row">
									<div className="col-xl-3 col-md-6 mb-4">
										<div className="card border-start-lg border-start-primary h-100">
											<div className="card-body">
												<div className="d-flex align-items-center">
													<div className="flex-grow-1">
														<div className="small fw-bold text-primary mb-1">{user.username} </div>
														<div className="h5 h5-cus">Mã khách hàng : {user.id}</div>
														<div className="text-xs fw-bold text-success d-inline-flex align-items-center">
															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-trending-up me-1">
																<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
																<polyline points="17 6 23 6 23 12"></polyline>
															</svg>
															&nbsp;{user.notes}
														</div>
													</div>
													<div className="ms-2">
														<FaRegUser style={{"color": "#e0e5ec", "fontSize": "2.5em"}} />
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-xl-3 col-md-6 mb-4">
										<div className="card border-start-lg border-start-secondary h-100">
											<div className="card-body">
												<div className="d-flex align-items-center">
													<div className="flex-grow-1">
														<div className="small fw-bold text-secondary mb-1">Số Dư</div>
														<div className="h5 h5-cus">
															<NumberFormat value={ user.money } displayType={'text'} thousandSeparator={true} suffix={' coin'} />
														</div>
														<div className="text-xs fw-bold text-danger d-inline-flex align-items-center">
															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-trending-down me-1">
																<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline>
																<polyline points="17 18 23 18 23 12"></polyline>
															</svg>
															&nbsp;3%
														</div>
													</div>
													<div className="ms-2">
														<FaMoneyCheckAlt style={{"color": "#e0e5ec", "fontSize": "2.5em"}} />
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-xl-3 col-md-6 mb-4">
										<div className="card border-start-lg border-start-success h-100">
											<div className="card-body">
												<div className="d-flex align-items-center">
													<div className="flex-grow-1">
														<div className="small fw-bold text-success mb-1">
															Số tiền đã tiêu
														</div>
														<div className="h5 h5-cus">
															<NumberFormat value={ user.tien_datieu } displayType={'text'} thousandSeparator={true} suffix={' coin'} />
														</div>
														<div className="text-xs fw-bold text-success d-inline-flex align-items-center">
															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-trending-up me-1">
																<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
																<polyline points="17 6 23 6 23 12"></polyline>
															</svg>
															&nbsp;12%
														</div>
													</div>
													<div className="ms-2">
														<FaDollarSign style={{"color": "#e0e5ec", "fontSize": "2.5em"}} />
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-xl-3 col-md-6 mb-4">
										<div className="card border-start-lg border-start-info h-100">
											<div className="card-body">
												<div className="d-flex align-items-center">
													<div className="flex-grow-1">
														<div className="small fw-bold text-info mb-1">
															Số tiền đã nạp
														</div>
														<div className="h5 h5-cus">
															<NumberFormat value={ user.tien_nap } displayType={'text'} thousandSeparator={true} suffix={' coin'} />
														</div>
														<div className="text-xs fw-bold text-danger d-inline-flex align-items-center">
															<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-trending-down me-1">
																<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline>
																<polyline points="17 18 23 18 23 12"></polyline>
															</svg>
															&nbsp;1%
														</div>
													</div>
													<div className="ms-2">
														<FaCoins style={{"color": "#e0e5ec", "fontSize": "2.5em"}} />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-4 mb-4">
										<div className="card mb-4">
											<div className="card-header">Top Nạp</div>
											<div className="card-body">
												{cardtopaacount}
											</div>
										</div>
									</div>
									<div className="col-lg-8 mb-4">
										<div className="card mb-4">
											<div className="card-header">Thông Báo :</div>
											<div className="card-body" style={{"maxHeight": "560px", "overflow": "auto"}}>
												{cardthongbao}
											</div>
										</div>
									</div>
								</div>
			    			</div>
			    		</div>
			    	</div>
				</div>
    		</Fragment>
		);
  	}
}

const mapStateToProps = state => ({
	auth: state.auth,
	adminpage: state.adminpage
});

export default connect(mapStateToProps, { getDataIsUser, saveDataUser,loadInfoUser, getDataFeature}) (Quanlytaikhoan);
